import { __rest } from 'tslib';
import * as React from 'react';
import React__default, { useMemo, useCallback, useState, createContext, useContext, forwardRef, Fragment, useEffect } from 'react';
import { Box, IconButton, AppBar, Toolbar, useTheme, Drawer, MenuItem, ListItemIcon, Typography, Grid, styled, Tabs, Tab, Menu as Menu$1, Accordion, AccordionSummary, ListItemText, AccordionDetails, List, ListItem, useMediaQuery, Stack, Dialog, DialogContent, DialogActions, TableContainer as TableContainer$1, TableRow, TableCell, Collapse, Table as Table$1, TableHead, TableBody, TableFooter, Skeleton, CssBaseline, Paper, Step, StepConnector, StepLabel, Stepper as Stepper$1 } from '@mui/material';
import { Menu, ExpandMore, CloseRounded, ExpandMoreRounded, MailRounded, LocalPhoneRounded, CheckRounded } from '@mui/icons-material';
import { makeG2STyles, ThemeContext } from '@komune-io/g2-themes';
import { Menu as Menu$2, Actions, Pagination, Presentation, Link as Link$1, Chip } from '@komune-io/g2-components';
import { cx } from '@emotion/css';
import { TextField, CheckBox } from '@komune-io/g2-forms';
import { useFlexLayout, useTable as useTable$1, useRowSelect, usePagination, useExpanded } from 'react-table';
import { Link } from 'react-router-dom';
import { Tooltip, StatusTag } from '@komune-io/g2-notifications';
import { formatNumber } from '@komune-io/g2-utils';
import { flexRender, useReactTable, getCoreRowModel, getExpandedRowModel } from '@tanstack/react-table';

const useStyles$8 = makeG2STyles()({
    root: {
        zIndex: 1100
    },
    iconButton: {
        marginRight: '20px'
    },
    toolbar: {
        paddingRight: '24px'
    }
});
const AppBarLayout = (props) => {
    const { className, style, id, children, classes, styles, onDrawerOpen, show = true } = props, other = __rest(props, ["className", "style", "id", "children", "classes", "styles", "onDrawerOpen", "show"]);
    const defaultStyles = useStyles$8();
    if (!show)
        return (React__default.createElement(Box, { className: defaultStyles.cx(defaultStyles.classes.root, 'AruiAppBar-root', className) },
            onDrawerOpen && (React__default.createElement(IconButton, { className: defaultStyles.cx(defaultStyles.classes.iconButton, 'AruiAppBar-menuButton', classes === null || classes === void 0 ? void 0 : classes.menuButton), color: 'inherit', "aria-label": 'Open drawer', onClick: onDrawerOpen, size: 'large' },
                React__default.createElement(Menu, { className: defaultStyles.cx('AruiAppBar-menuIcon', classes === null || classes === void 0 ? void 0 : classes.menuIcon), style: styles === null || styles === void 0 ? void 0 : styles.menuIcon }))),
            React__default.createElement(Box, { display: 'flex', className: defaultStyles.cx(defaultStyles.classes.toolbar, 'AruiAppBar-toolbar', classes === null || classes === void 0 ? void 0 : classes.toolBar), style: styles === null || styles === void 0 ? void 0 : styles.toolBar }, children)));
    return (React__default.createElement(AppBar, Object.assign({ className: defaultStyles.cx('AruiAppBar-root', className), id: id, style: style, square: true }, other),
        React__default.createElement(Toolbar, { className: defaultStyles.cx(defaultStyles.classes.toolbar, 'AruiAppBar-toolbar', classes === null || classes === void 0 ? void 0 : classes.toolBar), style: styles === null || styles === void 0 ? void 0 : styles.toolBar },
            onDrawerOpen && (React__default.createElement(IconButton, { className: defaultStyles.cx(defaultStyles.classes.iconButton, 'AruiAppBar-menuButton', classes === null || classes === void 0 ? void 0 : classes.menuButton), color: 'inherit', "aria-label": 'Open drawer', onClick: onDrawerOpen, size: 'large' },
                React__default.createElement(Menu, { className: defaultStyles.cx('AruiAppBar-menuIcon', classes === null || classes === void 0 ? void 0 : classes.menuIcon), style: styles === null || styles === void 0 ? void 0 : styles.menuIcon }))),
            children)));
};

const defaultAppStyleProps = {
    appBar: {
        height: 100,
        background: 'white'
    },
    menu: {
        width: 210,
        background: 'white',
        zIndex: 1200
    },
    main: {
        background: '#f4f4f4',
        padding: 24
    }
};
const applyAppStyleProps = (partial) => {
    if (!partial) {
        return defaultAppStyleProps;
    }
    return {
        appBar: Object.assign(Object.assign({}, defaultAppStyleProps.appBar), partial.appBar),
        menu: Object.assign(Object.assign({}, defaultAppStyleProps.menu), partial.menu),
        main: Object.assign(Object.assign({}, defaultAppStyleProps.main), partial.main)
    };
};

const useStyles$7 = makeG2STyles()((theme, props) => ({
    appbar: {
        height: `${props.styleProps.appBar.height}px`,
        background: props.styleProps.appBar.background,
        boxShadow: theme.shadows[4],
        '& .MuiToolbar-root': {
            height: '100%'
        },
        transition: props.muiTheme.transitions.create(['margin', 'width'], {
            easing: props.muiTheme.transitions.easing.sharp,
            duration: props.muiTheme.transitions.duration.leavingScreen
        })
    },
    appBarOpen: {
        width: `calc(100% - ${props.styleProps.menu.width}px)`,
        marginLeft: `${props.styleProps.menu.width}px`,
        transition: props.muiTheme.transitions.create(['margin', 'width'], {
            easing: props.muiTheme.transitions.easing.easeOut,
            duration: props.muiTheme.transitions.duration.enteringScreen
        })
    },
    titleContainer: {
        height: `${props.styleProps.appBar.height}px`,
        paddingLeft: '10px',
        display: 'flex',
        alignItems: 'center',
        position: 'fixed',
        marginLeft: `0px`,
        top: '0px',
        left: '0px',
        transition: props.muiTheme.transitions.create(['margin', 'width'], {
            easing: props.muiTheme.transitions.easing.sharp,
            duration: props.muiTheme.transitions.duration.leavingScreen
        })
    },
    titleContainerOpen: {
        marginLeft: `${props.styleProps.menu.width}px`,
        transition: props.muiTheme.transitions.create(['margin', 'width'], {
            easing: props.muiTheme.transitions.easing.easeOut,
            duration: props.muiTheme.transitions.duration.enteringScreen
        })
    },
    drawer: {
        width: `${props.styleProps.menu.width}px`,
        '& .MuiDrawer-paper': {
            top: `0px`,
            zIndex: props.styleProps.menu.zIndex,
            width: `${props.styleProps.menu.width}px`,
            background: props.styleProps.menu.background,
            height: `100vh`,
            overflowX: 'hidden',
            transition: props.muiTheme.transitions.create('transform', {
                easing: props.muiTheme.transitions.easing.sharp,
                duration: props.muiTheme.transitions.duration.enteringScreen
            })
        }
    },
    drawerClosed: {
        '& .MuiDrawer-paper': {
            transform: `translateX(-${props.styleProps.menu.width}px)`,
            transition: props.muiTheme.transitions.create('transform', {
                easing: props.muiTheme.transitions.easing.easeOut,
                duration: props.muiTheme.transitions.duration.leavingScreen
            })
        }
    },
    main: {
        background: props.styleProps.main.background,
        flexGrow: 1,
        transition: props.muiTheme.transitions.create('padding', {
            easing: props.muiTheme.transitions.easing.sharp,
            duration: props.muiTheme.transitions.duration.leavingScreen
        }),
        paddingTop: props.styleProps.appBar.height + props.styleProps.main.padding,
        paddingLeft: props.styleProps.menu.width + props.styleProps.main.padding,
        paddingRight: props.styleProps.main.padding,
        minHeight: '100vh',
        boxSizing: 'border-box'
    },
    mainShift: {
        flexGrow: 1,
        paddingTop: props.styleProps.appBar.height + props.styleProps.main.padding,
        transition: props.muiTheme.transitions.create('padding', {
            easing: props.muiTheme.transitions.easing.easeOut,
            duration: props.muiTheme.transitions.duration.enteringScreen
        }),
        paddingLeft: props.styleProps.main.padding,
        paddingRight: props.styleProps.main.padding,
        minHeight: '100vh',
        boxSizing: 'border-box'
    },
    hidder: {
        opacity: '0.5',
        position: 'fixed',
        height: '100vh',
        width: '100vw',
        backgroundColor: 'black',
        top: '0',
        left: '0',
        zIndex: 5
    }
}));
/**
 * @legacy
 */
const AppLayout = (props) => {
    const { children, appBarContent, appBarLayoutProps, drawerProps, showDrawer = true, drawerContent, open, styleProps, showAppBar = true, classes, styles, onToggle } = props;
    const muiTheme = useTheme();
    const stylesDependencies = useMemo(() => ({
        styleProps: applyAppStyleProps(styleProps),
        muiTheme: muiTheme
    }), [styleProps, muiTheme]);
    const defaultStyles = useStyles$7(stylesDependencies);
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Enter' && onToggle) {
            onToggle();
        }
    }, [onToggle]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(AppBarLayout, Object.assign({}, appBarLayoutProps, { className: showAppBar
                ? defaultStyles.cx(defaultStyles.classes.appbar, open && defaultStyles.classes.appBarOpen, appBarLayoutProps === null || appBarLayoutProps === void 0 ? void 0 : appBarLayoutProps.className)
                : defaultStyles.cx(defaultStyles.classes.titleContainer, open && defaultStyles.classes.titleContainerOpen, appBarLayoutProps === null || appBarLayoutProps === void 0 ? void 0 : appBarLayoutProps.className), onDrawerOpen: showDrawer ? onToggle : undefined, show: showAppBar }), appBarContent),
        showDrawer && (React__default.createElement(Drawer, Object.assign({ open: open, variant: 'persistent' }, drawerProps, { className: defaultStyles.cx(defaultStyles.classes.drawer, !open && defaultStyles.classes.drawerClosed, drawerProps === null || drawerProps === void 0 ? void 0 : drawerProps.className) }), drawerContent)),
        React__default.createElement("main", { className: defaultStyles.cx(open ? defaultStyles.classes.main : defaultStyles.classes.mainShift, 'AruiApp-main', classes === null || classes === void 0 ? void 0 : classes.main), style: styles === null || styles === void 0 ? void 0 : styles.main },
            React__default.createElement("div", { className: defaultStyles.classes.hidder, style: {
                    display: window.innerWidth < 768 && open && showDrawer ? 'block' : 'none'
                }, onClick: onToggle, onKeyDown: handleKeyDown }),
            children)));
};

const useStyles$6 = makeG2STyles()({
    gridContainer: {
        display: 'flex',
        padding: '5px',
        flexWrap: 'wrap',
        boxSizing: 'initial'
    },
    gridItem: {
        width: '110px',
        display: 'flex',
        height: '95px',
        margin: '3px',
        padding: '5px',
        flexWrap: 'nowrap',
        borderRadius: '3px',
        cursor: 'pointer',
        '& h6': {
            maxWidth: '100px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        },
        '&:hover h6': {
            textOverflow: 'initial',
            whiteSpace: 'initial'
        },
        '&:hover': {
            height: 'auto',
            minHeight: '90px',
            background: '#f5f5f5'
        }
    },
    gridRoot: {
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    item: {
        padding: '6px 15px'
    },
    icon: {
        minWidth: '0px',
        marginRight: '10px'
    }
});
const ItemsLayout = React__default.forwardRef((props, ref) => {
    const { menu, display = 'list', className, style, id, classes, styles } = props, other = __rest(props, ["menu", "display", "className", "style", "id", "classes", "styles"]);
    const defaultStyles = useStyles$6();
    if (display === 'list')
        return (React__default.createElement("div", Object.assign({ className: defaultStyles.cx('AruiItemsLayout-listRoot', className), style: style, id: id, ref: ref }, other), menu.items &&
            menu.items.map((it) => (React__default.createElement(MenuItem, { component: it.href ? 'a' : 'div', onClick: () => it.goto && !it.href && it.goto(), href: it.href, className: defaultStyles.cx(defaultStyles.classes.item, 'AruiItemsLayout-listItem', classes === null || classes === void 0 ? void 0 : classes.listItem), style: styles === null || styles === void 0 ? void 0 : styles.listItem, key: it.key },
                it.icon && (React__default.createElement(ListItemIcon, { classes: { root: defaultStyles.classes.icon } }, it.icon)),
                React__default.createElement(Typography, { variant: 'subtitle2' }, it.label))))));
    return (React__default.createElement("div", Object.assign({ className: defaultStyles.cx(defaultStyles.classes.gridRoot, 'AruiItemsLayout-gridRoot', className), style: style, id: id, ref: ref }, other),
        React__default.createElement(Grid, { wrap: 'wrap', container: true, direction: 'row', alignContent: 'flex-start', className: defaultStyles.cx(defaultStyles.classes.gridContainer, 'AruiItemsLayout-gridContainer', classes === null || classes === void 0 ? void 0 : classes.gridContainer), style: styles === null || styles === void 0 ? void 0 : styles.gridContainer }, menu.items &&
            menu.items.map((it) => (React__default.createElement(Grid, { key: it.key, component: it.href ? 'a' : 'div', onClick: () => it.goto && !it.href && it.goto(), href: it.href, alignItems: 'center', direction: 'column', justifyContent: 'space-around', className: defaultStyles.cx(defaultStyles.classes.gridItem, 'AruiItemsLayout-gridItem', classes === null || classes === void 0 ? void 0 : classes.gridItem), style: styles === null || styles === void 0 ? void 0 : styles.gridItem },
                it.icon,
                React__default.createElement(Typography, { variant: 'subtitle2', align: 'center' }, it.label)))))));
});

const useStyles$5 = makeG2STyles()({
    appBar: {
        background: 'transparent',
        boxShadow: 'none !important'
    },
    tab: {
        color: 'rgba(0, 0, 0, 0.87)',
        minWidth: '100px',
        maxWidth: '100px',
        minHeight: '10px',
        padding: '5px',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    tabFW: {
        color: 'rgba(0, 0, 0, 0.87)',
        minHeight: '10px',
        minWidth: '0',
        padding: '5px'
    }
});
const StyledTabs = styled(Tabs)({
    minHeight: '20px',
    borderBottom: '0.2px #8f8f8f solid',
    overflow: 'visible',
    '& .MuiTabs-indicator': {
        backgroundColor: '#4d4d4d',
        height: '2px',
        bottom: '-1px'
    },
    '& .MuiTabs-scroller': {
        overflow: 'visible !important'
    }
});
const TabsMenu = (props) => {
    const { tabs, children, style, className, variant = 'fullWidth', id, classes, styles } = props;
    const defaultStyles = useStyles$5();
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        event.stopPropagation();
        setValue(newValue);
    };
    return (React__default.createElement("div", { className: defaultStyles.cx('AruiTabsMenu-root', className), style: style, id: id },
        React__default.createElement(AppBar, { className: defaultStyles.cx(defaultStyles.classes.appBar, 'AruiTabsMenu-appBar', classes === null || classes === void 0 ? void 0 : classes.appBar), style: styles === null || styles === void 0 ? void 0 : styles.appBar, position: 'static' },
            React__default.createElement(StyledTabs, { value: value, style: variant === 'fixedWidth'
                    ? Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.tabs), { width: `${children.length * 100}px` }) : styles === null || styles === void 0 ? void 0 : styles.tabs, className: defaultStyles.cx('AruiTabsMenu-tabs', classes === null || classes === void 0 ? void 0 : classes.tabs), onChange: handleChange, variant: variant !== 'fullWidth' ? 'scrollable' : 'fullWidth', scrollButtons: 'auto' }, tabs.map((tab, index) => (React__default.createElement(Tab, { icon: tab.icon, key: index, className: defaultStyles.cx(variant !== 'fullWidth' && defaultStyles.classes.tab, variant === 'fullWidth' && defaultStyles.classes.tabFW, 'AruiTabsMenu-tab', classes === null || classes === void 0 ? void 0 : classes.tab), style: styles === null || styles === void 0 ? void 0 : styles.tab, label: tab.label }))))),
        children.map((child, index) => (React__default.createElement("div", { key: index, className: defaultStyles.cx('AruiTabsMenu-content', classes === null || classes === void 0 ? void 0 : classes.content), style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.content), { display: value !== index ? 'none' : 'block' }) }, child)))));
};

const useStyles$4 = makeG2STyles()({
    menu: {
        maxWidth: '300px',
        maxHeight: '500px'
    },
    menuGrid: {
        maxWidth: '375px'
    },
    list: {
        padding: '0 !important',
        width: '100% !important',
        '& > div': {
            outline: '0 !important'
        }
    },
    menuOpened: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
    },
    gridItemsLayoutMinWidth: {
        maxWidth: '375px',
        maxHeight: '410px',
        minWidth: '358px'
    },
    gridItemsLayout: {
        maxWidth: '375px',
        maxHeight: '410px'
    },
    listItemsLayout: {
        maxHeight: '410px',
        overflow: 'auto'
    }
});
const ToolsMenu = (props) => {
    const { menu, style, display = 'list', className, id, classes, styles, itemsLayoutProps, tabsMenuProps } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const defaultStyles = useStyles$4();
    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React__default.createElement("div", { className: defaultStyles.cx('AruiToolsMenu-root', className), style: style, id: id },
        React__default.createElement(IconButton, { className: defaultStyles.cx(!!open && defaultStyles.classes.menuOpened, 'AruiToolsMenu-iconButton', classes === null || classes === void 0 ? void 0 : classes.iconButton), style: styles === null || styles === void 0 ? void 0 : styles.iconButton, "aria-controls": 'menu-appbar', "aria-haspopup": 'true', onClick: handleMenu, color: 'inherit', size: 'large' }, menu.icon),
        React__default.createElement(Menu$1, { className: defaultStyles.cx('AruiToolsMenu-menu', classes === null || classes === void 0 ? void 0 : classes.menu), style: styles === null || styles === void 0 ? void 0 : styles.menu, classes: {
                paper: `${defaultStyles.classes.menu} ${display === 'grid' && defaultStyles.classes.menuGrid}`,
                list: defaultStyles.classes.list
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            }, anchorEl: anchorEl, transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
            }, keepMounted: true, open: open, onClose: handleClose }, menu.items && menu.items.length === 1 ? (React__default.createElement(ItemsLayout, Object.assign({ menu: menu.items[0], display: display }, itemsLayoutProps))) : (React__default.createElement("div", null, menu.items && (React__default.createElement(TabsMenu, Object.assign({ variant: display === 'list' ? 'fixedWidth' : 'fullWidth', tabs: menu.items.map((it) => {
                return { label: it.label || '', icon: it.icon };
            }) }, tabsMenuProps), menu.items &&
            menu.items.map((section, index) => (React__default.createElement("div", { key: index },
                React__default.createElement(ItemsLayout, Object.assign({ menu: section, display: display, className: display !== 'list'
                        ? section.items && section.items.length >= 3
                            ? defaultStyles.classes.gridItemsLayoutMinWidth
                            : defaultStyles.classes.gridItemsLayout
                        : defaultStyles.classes.listItemsLayout }, itemsLayoutProps))))))))))));
};

const useStyles$3 = makeG2STyles()({
    profile: {
        boxShadow: 'none !important',
        background: 'transparent',
        '&:before': {
            height: '0px'
        }
    },
    summary: {
        minHeight: '0px',
        padding: '0 10px'
    },
    content: {
        margin: '10px 0px !important'
    },
    expanded: {
        margin: '0 !important'
    },
    expandedSummary: {
        minHeight: '0px !important'
    },
    list: {
        width: '100%',
        padding: '0'
    },
    details: {
        padding: '0',
        background: '#f5f5f5'
    },
    icon: {
        alignItems: 'center'
    }
});
const ToolsPanel = (props) => {
    const { menu, style, className, id } = props;
    const { classes, cx } = useStyles$3();
    return (React__default.createElement(Accordion, { className: cx(classes.profile, 'AruiToolsPanel-root', className), style: style, id: id, classes: { expanded: classes.expanded } },
        React__default.createElement(AccordionSummary, { expandIcon: React__default.createElement(ExpandMore, null), className: classes.summary, classes: {
                expanded: classes.expandedSummary,
                content: classes.content
            } },
            React__default.createElement(ListItemIcon, null, menu.icon),
            React__default.createElement(ListItemText, { primary: menu.label })),
        React__default.createElement(AccordionDetails, { className: classes.details },
            React__default.createElement(List, { className: classes.list }, menu.items && menu.items.length <= 1
                ? menu.items[0].items &&
                    menu.items[0].items.map((item) => (React__default.createElement(ListItem, { button: true, key: item.key, onClick: () => item.goto && item.goto() },
                        item.icon && (React__default.createElement(ListItemIcon, { classes: { root: classes.icon } }, item.icon)),
                        React__default.createElement(ListItemText, { primary: item.label }))))
                : menu.items &&
                    menu.items.map((item) => {
                        return item.items ? (React__default.createElement(ToolsPanel, { key: item.key, menu: item })) : (React__default.createElement(ListItem, { button: true, key: item.key, onClick: () => item.goto && item.goto() },
                            item.icon && (React__default.createElement(ListItemIcon, { classes: { root: classes.icon } }, item.icon)),
                            React__default.createElement(ListItemText, { primary: item.label })));
                    })))));
};

const useStyles$2 = makeG2STyles()({
    drawerSpacer: {
        '& img': {
            marginTop: '5px',
            marginRight: '10px',
            height: '20px'
        }
    }
});
const TitleContainer = (props) => {
    const { classes, logo, className, title, styles } = props, other = __rest(props, ["classes", "logo", "className", "title", "styles"]);
    const defaultStyles = useStyles$2();
    return (React__default.createElement(Box, Object.assign({ display: 'flex', justifyContent: 'center', className: defaultStyles.cx(defaultStyles.classes.drawerSpacer, 'AruiTitleContainer-root', className) }, other),
        React__default.createElement(List, null,
            React__default.createElement(ListItem, { key: 'application', alignItems: 'center', component: 'div' },
                React__default.createElement(ListItemText, null, logo && (React__default.createElement("img", { src: logo, className: defaultStyles.cx('AruiTitleContainer-logo', classes === null || classes === void 0 ? void 0 : classes.logo), style: styles === null || styles === void 0 ? void 0 : styles.logo, alt: 'Logo' }))),
                title && (React__default.createElement(ListItemText, { primary: title, className: defaultStyles.cx('AruiTitleContainer-title', classes === null || classes === void 0 ? void 0 : classes.title), style: styles === null || styles === void 0 ? void 0 : styles.title }))))));
};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

const AppMenu = (props) => {
    const { logo, menu } = props, other = __rest(props, ["logo", "menu"]);
    const extendedMenu = useMemo(() => {
        var _a, _b;
        return logo
            ? [
                Object.assign(Object.assign({}, logo.item), { key: 'application-logo', componentProps: Object.assign({ sx: {
                            '& .MuiListItemIcon-root': {
                                width: '100%'
                            },
                            '& img': {
                                width: '100%'
                            }
                        } }, (_a = logo.item) === null || _a === void 0 ? void 0 : _a.componentProps), icon: (React__default.createElement("img", Object.assign({ src: logo.src, alt: 'The application logo' }, logo.imgProps, { className: clsx((_b = logo.imgProps) === null || _b === void 0 ? void 0 : _b.className, 'AruiAppMenu-logo') }))) }),
                ...menu
            ]
            : menu;
    }, [logo, menu]);
    return React__default.createElement(Menu$2, Object.assign({ menu: extendedMenu }, other));
};

const useStyles$1 = makeG2STyles()({
    grow: {
        flexGrow: 1
    }
});
// TODO App should use AppLayout instead of duplicate the code.
const App = (props) => {
    const { toolsMenuProps = [], navBarContent, menu, title, logo, titleLogo, showAppBar = true, drawerContent } = props, other = __rest(props, ["toolsMenuProps", "navBarContent", "menu", "title", "logo", "titleLogo", "showAppBar", "drawerContent"]);
    const defaultStyles = useStyles$1();
    const below600px = useMediaQuery('(max-width:600px)');
    const over400px = useMediaQuery('(min-width:400px)');
    return (React__default.createElement(AppLayout, Object.assign({}, other, { showAppBar: showAppBar, drawerContent: React__default.createElement(React__default.Fragment, null,
            menu && React__default.createElement(AppMenu, { menu: menu, logo: logo }),
            drawerContent,
            (below600px || !showAppBar) && navBarContent,
            (below600px || !showAppBar) &&
                toolsMenuProps &&
                toolsMenuProps.map((toolsMenuProps) => (React__default.createElement(ToolsPanel, { menu: toolsMenuProps.menu, key: toolsMenuProps.menu.key })))), appBarContent: showAppBar ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(TitleContainer, { title: title, logo: titleLogo }),
            React__default.createElement("div", { className: defaultStyles.cx(defaultStyles.classes.grow, 'AruiAppBar-flexFiller') }),
            !below600px && navBarContent,
            over400px &&
                toolsMenuProps.map((toolsMenuProps, index) => (React__default.createElement(ToolsMenu, Object.assign({ key: index }, toolsMenuProps)))))) : (React__default.createElement(TitleContainer, { title: title, logo: titleLogo })) })));
};

const Header = (props) => {
    const { content = [], freeContent, tabs, currentTab, withBottomDivider = true, isFixed = true, strongPadding = false, bgcolor, sx, onTabChange, tabsProps, classes, styles, className, zIndex = 300 } = props, rest = __rest(props, ["content", "freeContent", "tabs", "currentTab", "withBottomDivider", "isFixed", "strongPadding", "bgcolor", "sx", "onTabChange", "tabsProps", "classes", "styles", "className", "zIndex"]);
    const theme = useTheme();
    const contentDisplay = useMemo(() => content.map((it, index) => (React__default.createElement(Stack, { className: cx('AruiHeader-lineContainer', classes === null || classes === void 0 ? void 0 : classes.lineContainer), style: styles === null || styles === void 0 ? void 0 : styles.lineContainer, direction: 'row', sx: {
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: (theme) => theme.spacing(2)
        }, key: index },
        it.leftPart ? (React__default.createElement(Stack, { direction: 'row', className: cx('AruiHeader-leftPartContainer', classes === null || classes === void 0 ? void 0 : classes.leftPartContainer), style: styles === null || styles === void 0 ? void 0 : styles.leftPartContainer, sx: {
                alignItems: 'center',
                gap: (theme) => theme.spacing(2)
            }, key: `${index}-leftPart` }, it.leftPart)) : (React__default.createElement(Box, null)),
        it.rightPart ? (React__default.createElement(Stack, { className: cx('AruiHeader-rightPartContainer', classes === null || classes === void 0 ? void 0 : classes.rightPartContainer), style: styles === null || styles === void 0 ? void 0 : styles.rightPartContainer, direction: 'row', sx: {
                alignItems: 'center',
                gap: (theme) => theme.spacing(2),
                justifyContent: 'flex-end'
            }, key: `${index}-rightPart` }, it.rightPart)) : (React__default.createElement(Box, null))))), [content, classes, styles]);
    const tabsDisplay = useMemo(() => tabs &&
        tabs.map((tab) => (React__default.createElement(Tab, { disableRipple: true, key: tab.key, value: tab.key, label: tab.label, sx: {
                color: '#000000'
            } }))), [tabs]);
    return (React__default.createElement(Box, Object.assign({ className: cx('AruiHeader-root', className), sx: Object.assign({ [theme.breakpoints.down('sm')]: {
                padding: (theme) => {
                    const topPadding = theme.spacing(2);
                    const horizontalPadding = strongPadding
                        ? theme.spacing(2)
                        : theme.spacing(1);
                    if (tabs) {
                        return `${topPadding} ${horizontalPadding} 0`;
                    }
                    return `${topPadding} ${horizontalPadding}`;
                }
            }, padding: (theme) => {
                const topPadding = theme.spacing(2);
                const horizontalPadding = strongPadding
                    ? theme.spacing(5)
                    : theme.spacing(3);
                if (tabs) {
                    return `${topPadding} ${horizontalPadding} 0`;
                }
                return `${topPadding} ${horizontalPadding}`;
            }, borderBottom: withBottomDivider ? '1px solid #E0E0E0' : 'none', width: '100%', boxSizing: 'border-box', bgcolor: (theme) => {
                const color = bgcolor ? bgcolor : theme.palette.background.default;
                return color + '99';
            }, position: isFixed ? 'sticky' : 'relative', top: isFixed ? '0px' : undefined, backdropFilter: 'blur(15px)', webkitBackdropFilter: 'blur(15px)', zIndex: zIndex }, sx) }, rest),
        React__default.createElement(Stack, { className: cx('AruiHeader-contentContainer', classes === null || classes === void 0 ? void 0 : classes.contentContainer), style: styles === null || styles === void 0 ? void 0 : styles.contentContainer, sx: {
                gap: (theme) => theme.spacing(2)
            } },
            freeContent,
            contentDisplay,
            tabsDisplay && (React__default.createElement(Tabs, Object.assign({}, tabsProps, { className: cx('AruiHeader-tabs', classes === null || classes === void 0 ? void 0 : classes.tabs), style: styles === null || styles === void 0 ? void 0 : styles.tabs, value: currentTab, onChange: onTabChange, variant: 'scrollable', scrollButtons: 'auto', sx: Object.assign({ marginTop: (theme) => `-${theme.spacing(1.5)}`, marginBottom: '-1px' }, tabsProps === null || tabsProps === void 0 ? void 0 : tabsProps.sx) }), tabsDisplay)))));
};

const pageDefaultContext = {
    headerProps: undefined,
    bottomActionsProps: undefined,
    setPageContext: () => { }
};
const PageContext = createContext(pageDefaultContext);
const PageContextProvider = (props) => {
    const { children } = props, other = __rest(props, ["children"]);
    const [pageState, setPageState] = useState(Object.assign(Object.assign({}, other), props));
    return (React__default.createElement(PageContext.Provider, { value: Object.assign(Object.assign({}, pageState), { setPageContext: setPageState }) }, children));
};
const usePage = () => {
    return useContext(PageContext);
};

function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;

      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;

      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });

      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
var _isArray = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */

function _dispatchable(methodNames, transducerCreator, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }

    var obj = arguments[arguments.length - 1];

    if (!_isArray(obj)) {
      var idx = 0;

      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }

        idx += 1;
      }

      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }

    return fn.apply(this, arguments);
  };
}

var _xfBase = {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};

function _arrayFromIterator(iter) {
  var list = [];
  var next;

  while (!(next = iter.next()).done) {
    list.push(next.value);
  }

  return list;
}

function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
}

function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
}

var _objectIs$1 = typeof Object.is === 'function' ? Object.is : _objectIs;

var toString$1 = Object.prototype.toString;

var _isArguments =
/*#__PURE__*/
function () {
  return toString$1.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString$1.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
}();

var hasEnumBug = !
/*#__PURE__*/
{
  toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

var hasArgsEnumBug =
/*#__PURE__*/
function () {

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;

  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }

    idx += 1;
  }

  return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */


var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
/*#__PURE__*/
_curry1(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) :
/*#__PURE__*/
_curry1(function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }

  var prop, nIdx;
  var ks = [];

  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);

  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }

  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;

    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];

      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }

      nIdx -= 1;
    }
  }

  return ks;
});

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig * -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(async () => {}); //=> "AsyncFunction"
 *      R.type(undefined); //=> "Undefined"
 */

var type =
/*#__PURE__*/
_curry1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);

  var b = _arrayFromIterator(bIterator);

  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  } // if *a* array contains any element that is not included in *b*


  return !_includesWith(function (b, aItem) {
    return !_includesWith(eq, aItem, b);
  }, b, a);
}

function _equals(a, b, stackA, stackB) {
  if (_objectIs$1(a, b)) {
    return true;
  }

  var typeA = type(a);

  if (typeA !== type(b)) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
        return a === b;
      }

      break;

    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && _objectIs$1(a.valueOf(), b.valueOf()))) {
        return false;
      }

      break;

    case 'Date':
      if (!_objectIs$1(a.valueOf(), b.valueOf())) {
        return false;
      }

      break;

    case 'Error':
      return a.name === b.name && a.message === b.message;

    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }

      break;
  }

  var idx = stackA.length - 1;

  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }

    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));

    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));

    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;

    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys(a);

  if (keysA.length !== keys(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;

  while (idx >= 0) {
    var key = keysA[idx];

    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }

    idx -= 1;
  }

  return true;
}

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */

var equals =
/*#__PURE__*/
_curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});

function _indexOf(list, a, idx) {
  var inf, item; // Array.prototype.indexOf doesn't exist below IE9

  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;

          while (idx < list.length) {
            item = list[idx];

            if (item === 0 && 1 / item === inf) {
              return idx;
            }

            idx += 1;
          }

          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];

            if (typeof item === 'number' && item !== item) {
              return idx;
            }

            idx += 1;
          }

          return -1;
        } // non-zero numbers can utilise Set


        return list.indexOf(a, idx);
      // all these types can utilise Set

      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }

    }
  } // anything else not covered above, defer to R.equals


  while (idx < list.length) {
    if (equals(list[idx], a)) {
      return idx;
    }

    idx += 1;
  }

  return -1;
}

function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}

function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);

  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }

  return result;
}

function _quote(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

function _arrayReduce(reducer, acc, list) {
  var index = 0;
  var length = list.length;

  while (index < length) {
    acc = reducer(acc, list[index]);
    index += 1;
  }

  return acc;
}

function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }

    idx += 1;
  }

  return result;
}

function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

var XFilter =
/*#__PURE__*/
function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;

  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

function _xfilter(f) {
  return function (xf) {
    return new XFilter(f, xf);
  };
}

/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @category Object
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */

var filter =
/*#__PURE__*/
_curry2(
/*#__PURE__*/
_dispatchable(['fantasy-land/filter', 'filter'], _xfilter, function (pred, filterable) {
  return _isObject(filterable) ? _arrayReduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }

    return acc;
  }, {}, keys(filterable)) : // else
  _filter(pred, filterable);
}));

/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */

var reject =
/*#__PURE__*/
_curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});

function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _includes(y, xs) ? '<Circular>' : _toString(y, xs);
  }; //  mapPairs :: (Object, [String]) -> [String]


  var mapPairs = function (obj, keys) {
    return _map(function (k) {
      return _quote(k) + ': ' + recur(obj[k]);
    }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';

    case '[object Array]':
      return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
        return /^\d+$/.test(k);
      }, keys(x)))).join(', ') + ']';

    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();

    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';

    case '[object Map]':
      return 'new Map(' + recur(Array.from(x)) + ')';

    case '[object Null]':
      return 'null';

    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);

    case '[object Set]':
      return 'new Set(' + recur(Array.from(x).sort()) + ')';

    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);

    case '[object Undefined]':
      return 'undefined';

    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();

        if (repr !== '[object Object]') {
          return repr;
        }
      }

      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
  }
}

/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */

var toString =
/*#__PURE__*/
_curry1(function toString(val) {
  return _toString(val, []);
});

function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

function _isFunction(x) {
  var type = Object.prototype.toString.call(x);
  return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
}

/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */

var concat =
/*#__PURE__*/
_curry2(function concat(a, b) {
  if (_isArray(a)) {
    if (_isArray(b)) {
      return a.concat(b);
    }

    throw new TypeError(toString(b) + ' is not an array');
  }

  if (_isString(a)) {
    if (_isString(b)) {
      return a + b;
    }

    throw new TypeError(toString(b) + ' is not a string');
  }

  if (a != null && _isFunction(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }

  if (a != null && _isFunction(a.concat)) {
    return a.concat(b);
  }

  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});

/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */

var mergeWithKey =
/*#__PURE__*/
_curry3(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;
  l = l || {};
  r = r || {};

  for (k in l) {
    if (_has(k, l)) {
      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (_has(k, r) && !_has(k, result)) {
      result[k] = r[k];
    }
  }

  return result;
});

/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */

var mergeDeepWithKey =
/*#__PURE__*/
_curry3(function mergeDeepWithKey(fn, lObj, rObj) {
  return mergeWithKey(function (k, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});

/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */

var mergeDeepWith =
/*#__PURE__*/
_curry3(function mergeDeepWith(fn, lObj, rObj) {
  return mergeDeepWithKey(function (k, lVal, rVal) {
    return fn(lVal, rVal);
  }, lObj, rObj);
});

const mergeHeaderContent = (key, l, r) => {
    if (key === 'content') {
        if (r.lentgh > l.length) {
            return l.map((el, index) => {
                var _a, _b, _c, _d;
                return ({
                    //@ts-ignore
                    leftPart: concat((_a = el.leftPart) !== null && _a !== void 0 ? _a : [], (_b = r[index].leftPart) !== null && _b !== void 0 ? _b : []),
                    //@ts-ignore
                    rightPart: concat((_c = el.rightPart) !== null && _c !== void 0 ? _c : [], (_d = r[index].rightPart) !== null && _d !== void 0 ? _d : [])
                });
            });
        }
        else {
            return r.map((el, index) => {
                var _a, _b, _c, _d;
                return ({
                    //@ts-ignore
                    leftPart: concat((_a = el.leftPart) !== null && _a !== void 0 ? _a : [], (_b = l[index].leftPart) !== null && _b !== void 0 ? _b : []),
                    //@ts-ignore
                    rightPart: concat((_c = el.rightPart) !== null && _c !== void 0 ? _c : [], (_d = l[index].rightPart) !== null && _d !== void 0 ? _d : [])
                });
            });
        }
    }
    return r !== null && r !== void 0 ? r : l;
};
const Page = (props) => {
    const { children, headerProps, bottomActionsProps, className, flexContent = false, sx } = props, other = __rest(props, ["children", "headerProps", "bottomActionsProps", "className", "flexContent", "sx"]);
    const [pageDescendantContext, setPageDescendantContext] = useState(pageDefaultContext);
    const pageAscendantContext = usePage();
    const theme = useTheme();
    const { theme: g2Theme, openDrawer } = useContext(ThemeContext);
    const isMobile = g2Theme.drawerAbsolutePositionBreakpoint === 'always'
        ? true
        : useMediaQuery(theme.breakpoints.down(g2Theme.drawerAbsolutePositionBreakpoint));
    const actionsDisplay = useMemo(() => {
        if (!bottomActionsProps)
            return undefined;
        return (React__default.createElement(Actions, Object.assign({}, mergeDeepWith(concat, pageAscendantContext.bottomActionsProps, mergeDeepWith(concat, pageDescendantContext.bottomActionsProps, bottomActionsProps)), { sx: {
                marginTop: !flexContent ? (theme) => theme.spacing(4) : ''
            } })));
    }, [
        bottomActionsProps,
        flexContent,
        pageDescendantContext,
        pageAscendantContext
    ]);
    const headerDisplay = useMemo(() => {
        var _a;
        if (!headerProps)
            return undefined;
        return (React__default.createElement(Header, Object.assign({ strongPadding: true }, mergeDeepWithKey(mergeHeaderContent, pageAscendantContext.headerProps, mergeDeepWithKey(mergeHeaderContent, pageDescendantContext.headerProps, headerProps)), { sx: Object.assign(Object.assign({ paddingLeft: g2Theme.permanentHeader && (!openDrawer || isMobile)
                    ? `${g2Theme.drawerWidth + (isMobile ? 5 : 40)}px !important`
                    : undefined, transition: g2Theme.permanentHeader
                    ? !openDrawer
                        ? theme.transitions.create(['padding'], {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.leavingScreen
                        })
                        : theme.transitions.create(['padding'], {
                            easing: theme.transitions.easing.easeOut,
                            duration: theme.transitions.duration.enteringScreen
                        })
                    : undefined }, (_a = pageDescendantContext.headerProps) === null || _a === void 0 ? void 0 : _a.sx), headerProps.sx) })));
    }, [
        headerProps,
        pageDescendantContext,
        pageAscendantContext,
        g2Theme,
        openDrawer,
        isMobile
    ]);
    return (React__default.createElement(React__default.Fragment, null,
        headerDisplay,
        React__default.createElement(Box, { className: 'AruiPage-pageCenterer', sx: {
                display: 'flex',
                justifyContent: 'center'
            } },
            React__default.createElement(Box, Object.assign({ className: cx('AruiPage-root', className), sx: Object.assign({ [theme.breakpoints.down('sm')]: {
                        padding: (theme) => theme.spacing(1),
                        paddingTop: (theme) => theme.spacing(2),
                        gap: flexContent ? (theme) => theme.spacing(2) : ''
                    }, padding: (theme) => theme.spacing(5), maxWidth: '1700px', width: '100%', flexGrow: 1, display: flexContent ? 'flex' : '', flexDirection: flexContent ? 'column' : undefined, gap: flexContent ? (theme) => theme.spacing(4) : '' }, sx) }, other),
                React__default.createElement(PageContext.Provider, { value: Object.assign(Object.assign({}, pageDescendantContext), { setPageContext: setPageDescendantContext }) },
                    children,
                    actionsDisplay)))));
};

const useStyles = makeG2STyles()((theme) => ({
    paper: {
        borderRadius: '16px'
    },
    actionsContainer: {
        padding: `${theme.spacing * 3}px`,
        paddingTop: '0px'
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
        width: 20,
        height: 20,
        color: '#676879'
    },
    content: {
        padding: `${theme.spacing * 5}px`
    },
    button: {
        margin: theme.spacing / 2
    }
}));
const PopUpBase = (props, ref) => {
    const { open, onClose, actions = [], children, style, className, id, classes, styles } = props, other = __rest(props, ["open", "onClose", "actions", "children", "style", "className", "id", "classes", "styles"]);
    const defaultStyles = useStyles();
    const actionsDisplay = useMemo(() => {
        if (actions.length === 0)
            return undefined;
        const styledAction = actions.map((action) => (Object.assign(Object.assign({}, action), { style: styles === null || styles === void 0 ? void 0 : styles.button, className: defaultStyles.cx(defaultStyles.classes.button, 'AruiPopUp-button', classes === null || classes === void 0 ? void 0 : classes.button, className) })));
        return React__default.createElement(Actions, { actions: styledAction });
    }, [actions, classes === null || classes === void 0 ? void 0 : classes.button, styles === null || styles === void 0 ? void 0 : styles.button]);
    return (React__default.createElement(Dialog, Object.assign({ ref: ref, open: open, onClose: onClose, style: style, id: id, PaperProps: {
            elevation: 12,
            className: defaultStyles.classes.paper
        }, className: defaultStyles.cx('AruiPopUp-root', className) }, other),
        React__default.createElement(CloseRounded, { className: defaultStyles.cx(defaultStyles.classes.closeIcon, 'AruiPopUp-closeIcon', classes === null || classes === void 0 ? void 0 : classes.closeIcon), style: styles === null || styles === void 0 ? void 0 : styles.closeIcon, onClick: onClose }),
        React__default.createElement(DialogContent, { className: defaultStyles.cx(defaultStyles.classes.content, 'AruiPopUp-content', classes === null || classes === void 0 ? void 0 : classes.content), style: styles === null || styles === void 0 ? void 0 : styles.content }, children),
        actionsDisplay !== undefined && (React__default.createElement(DialogActions, { className: defaultStyles.cx(defaultStyles.classes.actionsContainer, 'AruiPopUp-actions', classes === null || classes === void 0 ? void 0 : classes.actions), style: styles === null || styles === void 0 ? void 0 : styles.actions }, actionsDisplay))));
};
const PopUp = forwardRef(PopUpBase);

const ConfirmationPopUp = (props) => {
    const { onClose, onConfirm, open = false, children, strongConfirmation = false, strongConfirmationText = (React__default.createElement(React__default.Fragment, null,
        "Please confirm by typing the word: ",
        React__default.createElement("strong", null, "confirmation"),
        " in the field below:")), strongConfirmationWord = 'confirmation', strongConfirmationErrorText = 'The word typed is wrong', validateText = 'Confirm', cancelText = 'Cancel', classes, styles, className, variant } = props, other = __rest(props, ["onClose", "onConfirm", "open", "children", "strongConfirmation", "strongConfirmationText", "strongConfirmationWord", "strongConfirmationErrorText", "validateText", "cancelText", "classes", "styles", "className", "variant"]);
    const [value, setValue] = useState('');
    const [error, setError] = useState(strongConfirmation);
    const onValueChange = useCallback((value) => {
        setValue(value);
        if (value === strongConfirmationWord)
            setError(false);
        else
            setError(true);
    }, [strongConfirmationWord]);
    const handleClose = useCallback((event) => {
        setValue('');
        onClose(event);
    }, [onClose]);
    const actions = useMemo(() => [
        {
            key: 'ConfirmationPopUp-' + cancelText,
            label: cancelText,
            variant: 'text',
            onClick: handleClose
        },
        {
            key: 'ConfirmationPopUp-' + validateText,
            label: validateText,
            onClick: onConfirm,
            variant: variant === 'deletion' ? 'deletion' : 'contained',
            disabled: error
        }
    ], [validateText, cancelText, handleClose, onConfirm, error, variant]);
    return (React__default.createElement(PopUp, Object.assign({ open: open, actions: actions, onClose: handleClose, className: cx('AruiConfirmationPopUp-strongConfirmationText', className) }, other), strongConfirmation ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { className: cx('AruiConfirmationPopUp-strongConfirmationText', classes === null || classes === void 0 ? void 0 : classes.strongConfirmationText), style: styles === null || styles === void 0 ? void 0 : styles.strongConfirmationText, variant: 'body1' }, strongConfirmationText),
        React__default.createElement(TextField, { value: value, onChange: onValueChange, size: 'small', error: error, errorMessage: strongConfirmationErrorText, className: cx('AruiConfirmationPopUp-textField', classes === null || classes === void 0 ? void 0 : classes.textField), style: styles === null || styles === void 0 ? void 0 : styles.textField }))) : (children)));
};

const UseCompleteTable = (variant, options, ...plugins) => {
    const allPlugins = variant === 'grounded' ? plugins : [...plugins, useFlexLayout];
    //@ts-ignore
    return useTable$1(options, ...allPlugins);
};

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.844 1.313 1.656 10.5l9.188 9.188"
  })));
};

const Arrow = React__default.forwardRef((props, ref) => {
    const { color = '#828282' } = props;
    return React__default.createElement(SvgArrowLeft, Object.assign({ stroke: color, ref: ref }, props));
});

const BasicTableContainer = (props) => {
    const { children } = props, other = __rest(props, ["children"]);
    delete other.expandInElevatedRow;
    delete other.getRowLink;
    return React__default.createElement(TableContainer$1, Object.assign({}, other), children);
};
const TableContainer = styled(BasicTableContainer)((props) => {
    const { variant, theme, expandInElevatedRow, getRowLink } = props;
    const comunStyles = {
        '& .AruiTable-actionColumn': {
            width: '65px',
            maxWidth: '65px'
        },
        '& .AruiTable-pagination': {
            marginTop: '30px'
        },
        '& .AruiTable-tableRow': {
            '& .AruiTable-rowHoveredComponentContainer': {
                display: 'none'
            },
            position: 'relative'
        },
        '& .AruiTable-tableRow:hover': {
            '& .AruiTable-rowHoveredComponentContainer': {
                display: 'block'
            }
        },
        '& .AruiTable-tableHead': {
            // backgroundColor: '#ffffff99',
            position: 'sticky',
            // top: '0px',
            // backdropFilter: 'blur(15px)',
            zIndex: 5
        },
        '& .AruiTable-table': {
            borderCollapse: 'unset'
        },
        '& .AruiTable-tableCell': getRowLink
            ? {
                zIndex: 2,
                position: 'relative',
                pointerEvents: 'none'
            }
            : undefined,
        '& .AruiTable-tableCell :is(button, a, label)': getRowLink
            ? {
                pointerEvents: 'auto'
            }
            : undefined
    };
    if (variant === 'grounded') {
        return Object.assign(Object.assign({}, comunStyles), { '& .MuiTableCell-root': {
                borderBottomColor: '#D9DBE1'
            }, '& .AruiTable-principaleTableRow, .AruiTable-tableFooterRow': {
                '& > *': { borderBottom: 'unset ' }
            } });
    }
    else {
        return Object.assign(Object.assign({}, comunStyles), { '& .MuiTableCell-root': {
                border: 'unset'
            }, '& .AruiTable-principaleTableRow, .AruiTable-tableFooterRow': {
                borderRadius: theme.shape.borderRadius,
                background: 'white',
                boxShadow: theme.shadows[1],
                margin: '3px 0px',
                border: '2px solid transparent',
                minWidth: 'fit-content !important',
                marginBottom: expandInElevatedRow ? '20px' : ''
            }, '& .AruiTable-tableHeaderRow': {
                minWidth: 'fit-content !important'
            }, '& .AruiTable-tableCell, .AruiTable-tableHeaderCell, .AruiTable-tableFooterCell': {
                padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
                alignSelf: 'center'
            }, '& .AruiTable-table': {
                width: '100%'
            } });
    }
});

const GroundedBase = (props) => {
    const { headerGroups, prepareRow, rows, classes, onRowClicked, page, renderSubComponent, styles, tableProps, selectedRowIds, footerGroups, withFooter, renderRowHoveredComponent, toggleExpandOnRowClicked, toggleRowExpanded, additionalRowsProps = {}, getRowId, getRowLink } = props;
    const rowsDisplay = useMemo(() => {
        return rows.map((row) => {
            var _a;
            prepareRow(row);
            row.getRowProps();
            const rowProps = row.getRowProps();
            const extProps = (_a = additionalRowsProps[getRowId ? getRowId(row.original) : '']) !== null && _a !== void 0 ? _a : additionalRowsProps === null || additionalRowsProps === void 0 ? void 0 : additionalRowsProps.all;
            return (React__default.createElement(Fragment, { key: rowProps.key },
                React__default.createElement(TableRow, Object.assign({}, extProps, rowProps, { onClick: () => {
                        onRowClicked && onRowClicked(row);
                        toggleExpandOnRowClicked && toggleRowExpanded([row.id]);
                    }, className: cx(rowProps.className, extProps === null || extProps === void 0 ? void 0 : extProps.className, 'AruiTable-principaleTableRow', 'AruiTable-tableRow', classes === null || classes === void 0 ? void 0 : classes.tableRow), style: styles === null || styles === void 0 ? void 0 : styles.tableRow }),
                    row.cells.map((cell) => {
                        const column = cell.column;
                        return (React__default.createElement(TableCell, Object.assign({ className: cx(
                            //@ts-ignore
                            column.className, 'AruiTable-tableCell', classes === null || classes === void 0 ? void 0 : classes.tableCell), 
                            //@ts-ignore
                            style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableCell) }, cell.getCellProps()), cell.render('Cell')));
                    }),
                    !!renderRowHoveredComponent && (React__default.createElement(TableCell, { sx: {
                            padding: 0,
                            position: 'absolute',
                            width: '100%',
                            height: '100%'
                        }, className: cx('AruiTable-rowHoveredComponentContainer', classes === null || classes === void 0 ? void 0 : classes.rowHoveredComponentContainer), style: styles === null || styles === void 0 ? void 0 : styles.rowHoveredComponentContainer }, renderRowHoveredComponent(row))),
                    getRowLink && (React__default.createElement(TableCell, { sx: {
                            padding: 0,
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            zIndex: 1,
                            top: 0,
                            left: 0
                        }, className: 'AruiTable-rowLinkContainer' },
                        React__default.createElement(Link, Object.assign({}, getRowLink(row), { style: {
                                position: 'absolute',
                                width: '100%',
                                height: '100%'
                            } }))))),
                React__default.createElement(TableRow, { className: cx('AruiTable-tableRow', classes === null || classes === void 0 ? void 0 : classes.tableRow), style: styles === null || styles === void 0 ? void 0 : styles.tableRow },
                    React__default.createElement(TableCell, { sx: { paddingBottom: 0, paddingTop: 0 }, colSpan: 100 },
                        React__default.createElement(Collapse, { in: row.isExpanded, timeout: 'auto', unmountOnExit: true }, renderSubComponent && renderSubComponent(row, rowProps))))));
        });
    }, [
        rows,
        renderSubComponent,
        prepareRow,
        renderRowHoveredComponent,
        classes === null || classes === void 0 ? void 0 : classes.rowHoveredComponentContainer,
        styles === null || styles === void 0 ? void 0 : styles.rowHoveredComponentContainer,
        classes === null || classes === void 0 ? void 0 : classes.tableRow,
        styles === null || styles === void 0 ? void 0 : styles.tableRow,
        classes === null || classes === void 0 ? void 0 : classes.tableCell,
        styles === null || styles === void 0 ? void 0 : styles.tableCell,
        onRowClicked,
        toggleExpandOnRowClicked,
        toggleRowExpanded,
        selectedRowIds,
        additionalRowsProps,
        getRowId,
        getRowLink
    ]);
    const headerDisplay = useMemo(() => headerGroups.map((headerGroup) => (React__default.createElement(TableRow, Object.assign({ className: cx('AruiTable-tableHeaderRow', classes === null || classes === void 0 ? void 0 : classes.tableHeaderRow), style: styles === null || styles === void 0 ? void 0 : styles.tableHeaderRow }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column) => {
        return (React__default.createElement(TableCell, Object.assign({ className: cx(
            //@ts-ignore
            column.className, 'AruiTable-tableHeaderCell', classes === null || classes === void 0 ? void 0 : classes.tableHeaderCell), 
            //@ts-ignore
            style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableHeaderCell), variant: 'head' }, column.getHeaderProps()), column.id !== 'selection' ? (React__default.createElement(Typography, { variant: 'subtitle1' }, column.render('Header'))) : (column.render('Header'))));
    })))), [
        headerGroups,
        selectedRowIds,
        page,
        classes === null || classes === void 0 ? void 0 : classes.tableHeaderRow,
        styles === null || styles === void 0 ? void 0 : styles.tableHeaderRow,
        classes === null || classes === void 0 ? void 0 : classes.tableHeaderCell,
        styles === null || styles === void 0 ? void 0 : styles.tableHeaderCell
    ]);
    const footerDisplay = useMemo(() => !withFooter
        ? undefined
        : footerGroups.map((footerGroup) => (React__default.createElement(TableRow, Object.assign({ className: cx('AruiTable-tableFooterRow', classes === null || classes === void 0 ? void 0 : classes.tableFooterRow), style: styles === null || styles === void 0 ? void 0 : styles.tableFooterRow }, footerGroup.getFooterGroupProps()), footerGroup.headers.map((column) => {
            return (React__default.createElement(TableCell, Object.assign({ className: cx(
                //@ts-ignore
                column.className, 'AruiTable-tableFooterCell', classes === null || classes === void 0 ? void 0 : classes.tableFooterCell), 
                //@ts-ignore
                style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableFooterCell), variant: 'body' }, column.getFooterProps()), column.render('Footer')));
        })))), [
        footerGroups,
        classes === null || classes === void 0 ? void 0 : classes.tableFooterRow,
        styles === null || styles === void 0 ? void 0 : styles.tableFooterRow,
        classes === null || classes === void 0 ? void 0 : classes.tableFooterCell,
        styles === null || styles === void 0 ? void 0 : styles.tableFooterCell,
        withFooter
    ]);
    return (React__default.createElement(Table$1, Object.assign({ className: cx('AruiTable-table', classes === null || classes === void 0 ? void 0 : classes.table), style: styles === null || styles === void 0 ? void 0 : styles.table }, tableProps),
        React__default.createElement(TableHead, { className: cx('AruiTable-tableHead', classes === null || classes === void 0 ? void 0 : classes.tableHead), style: styles === null || styles === void 0 ? void 0 : styles.tableHead }, headerDisplay),
        React__default.createElement(TableBody, { className: cx('AruiTable-tableBody', classes === null || classes === void 0 ? void 0 : classes.tableBody), style: styles === null || styles === void 0 ? void 0 : styles.tableBody }, rowsDisplay),
        footerDisplay && (React__default.createElement(TableFooter, { className: cx('AruiTable-tableFooter', classes === null || classes === void 0 ? void 0 : classes.tableFooter), style: styles === null || styles === void 0 ? void 0 : styles.tableFooter }, footerDisplay))));
};

const ElevatedBase = (props) => {
    const { headerGroups, prepareRow, rows, classes, onRowClicked, page, renderSubComponent, styles, tableProps, selectedRowIds, footerGroups, withFooter, renderRowHoveredComponent, expandInRow, toggleExpandOnRowClicked, toggleRowExpanded, additionalRowsProps = {}, getRowId, getRowLink } = props;
    const rowsDisplay = useMemo(() => {
        return rows.map((row) => {
            var _a;
            prepareRow(row);
            row.getRowProps();
            const rowProps = row.getRowProps();
            const extProps = (_a = additionalRowsProps[getRowId ? getRowId(row.original) : '']) !== null && _a !== void 0 ? _a : additionalRowsProps === null || additionalRowsProps === void 0 ? void 0 : additionalRowsProps.all;
            return (React__default.createElement(Fragment, { key: rowProps.key },
                React__default.createElement(Box, Object.assign({}, extProps, { onClick: () => {
                        onRowClicked && onRowClicked(row);
                        toggleExpandOnRowClicked && toggleRowExpanded([row.id]);
                    }, className: cx(extProps === null || extProps === void 0 ? void 0 : extProps.className, 'AruiTable-principaleTableRow', 'AruiTable-tableRow', classes === null || classes === void 0 ? void 0 : classes.tableRow), style: styles === null || styles === void 0 ? void 0 : styles.tableRow }),
                    React__default.createElement(Box, Object.assign({}, rowProps),
                        row.cells.map((cell) => {
                            const column = cell.column;
                            return (React__default.createElement(Box, Object.assign({ className: cx(
                                //@ts-ignore
                                column.className, 'AruiTable-tableCell', classes === null || classes === void 0 ? void 0 : classes.tableCell), 
                                //@ts-ignore
                                style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableCell) }, cell.getCellProps()), cell.render('Cell')));
                        }),
                        !!renderRowHoveredComponent && (React__default.createElement(Box, { sx: {
                                padding: 0,
                                position: 'absolute',
                                width: '100%',
                                height: '100%'
                            }, className: cx('AruiTable-rowHoveredComponentContainer', classes === null || classes === void 0 ? void 0 : classes.rowHoveredComponentContainer), style: styles === null || styles === void 0 ? void 0 : styles.rowHoveredComponentContainer }, renderRowHoveredComponent(row)))),
                    getRowLink && (React__default.createElement(Box, { sx: {
                            padding: 0,
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            zIndex: 1,
                            top: 0,
                            left: 0
                        }, className: 'AruiTable-rowLinkContainer' },
                        React__default.createElement(Link, Object.assign({}, getRowLink(row), { style: {
                                position: 'absolute',
                                width: '100%',
                                height: '100%'
                            } })))),
                    expandInRow && (React__default.createElement(Collapse, { in: row.isExpanded, timeout: 'auto', unmountOnExit: true }, renderSubComponent && renderSubComponent(row, rowProps)))),
                !expandInRow && (React__default.createElement(Box, { className: cx('AruiTable-tableRow', classes === null || classes === void 0 ? void 0 : classes.tableRow), style: styles === null || styles === void 0 ? void 0 : styles.tableRow },
                    React__default.createElement(Box, { className: cx('AruiTable-tableCell', classes === null || classes === void 0 ? void 0 : classes.tableCell), style: styles === null || styles === void 0 ? void 0 : styles.tableCell, sx: { paddingBottom: 0, paddingTop: 0 } },
                        React__default.createElement(Collapse, { in: row.isExpanded, timeout: 'auto', unmountOnExit: true }, renderSubComponent && renderSubComponent(row, rowProps)))))));
        });
    }, [
        rows,
        renderSubComponent,
        prepareRow,
        renderRowHoveredComponent,
        classes === null || classes === void 0 ? void 0 : classes.rowHoveredComponentContainer,
        styles === null || styles === void 0 ? void 0 : styles.rowHoveredComponentContainer,
        classes === null || classes === void 0 ? void 0 : classes.tableRow,
        styles === null || styles === void 0 ? void 0 : styles.tableRow,
        classes === null || classes === void 0 ? void 0 : classes.tableCell,
        styles === null || styles === void 0 ? void 0 : styles.tableCell,
        onRowClicked,
        selectedRowIds,
        expandInRow,
        toggleExpandOnRowClicked,
        toggleRowExpanded,
        additionalRowsProps,
        getRowId,
        getRowLink
    ]);
    const headerDisplay = useMemo(() => headerGroups.map((headerGroup) => (React__default.createElement(Box, Object.assign({ className: cx('AruiTable-tableHeaderRow', classes === null || classes === void 0 ? void 0 : classes.tableHeaderRow), style: styles === null || styles === void 0 ? void 0 : styles.tableHeaderRow }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column) => (React__default.createElement(Box, Object.assign({ className: cx(
        //@ts-ignore
        column.className, 'AruiTable-tableHeaderCell', classes === null || classes === void 0 ? void 0 : classes.tableHeaderCell), 
        //@ts-ignore
        style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableHeaderCell) }, column.getHeaderProps()), column.id !== 'selection' ? (React__default.createElement(Typography, { variant: 'subtitle1' }, column.render('Header'))) : (column.render('Header')))))))), [
        headerGroups,
        selectedRowIds,
        page,
        classes === null || classes === void 0 ? void 0 : classes.tableHeaderRow,
        styles === null || styles === void 0 ? void 0 : styles.tableHeaderRow,
        classes === null || classes === void 0 ? void 0 : classes.tableHeaderCell,
        styles === null || styles === void 0 ? void 0 : styles.tableHeaderCell
    ]);
    const footerDisplay = useMemo(() => !withFooter
        ? undefined
        : footerGroups.map((footerGroup) => (React__default.createElement(Box, Object.assign({ className: cx('AruiTable-tableFooterRow', classes === null || classes === void 0 ? void 0 : classes.tableFooterRow), style: styles === null || styles === void 0 ? void 0 : styles.tableFooterRow }, footerGroup.getFooterGroupProps()), footerGroup.headers.map((column) => {
            return (React__default.createElement(Box, Object.assign({ className: cx(
                //@ts-ignore
                column.className, 'AruiTable-tableFooterCell', classes === null || classes === void 0 ? void 0 : classes.tableFooterCell), 
                //@ts-ignore
                style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableFooterCell) }, column.getFooterProps()), column.render('Footer')));
        })))), [
        footerGroups,
        classes === null || classes === void 0 ? void 0 : classes.tableFooterRow,
        styles === null || styles === void 0 ? void 0 : styles.tableFooterRow,
        classes === null || classes === void 0 ? void 0 : classes.tableFooterCell,
        styles === null || styles === void 0 ? void 0 : styles.tableFooterCell,
        withFooter
    ]);
    return (React__default.createElement(Box, Object.assign({ className: cx('AruiTable-table', classes === null || classes === void 0 ? void 0 : classes.table), style: styles === null || styles === void 0 ? void 0 : styles.table }, tableProps),
        React__default.createElement(Box, { className: cx('AruiTable-tableHead', classes === null || classes === void 0 ? void 0 : classes.tableHead), style: styles === null || styles === void 0 ? void 0 : styles.tableHead }, headerDisplay),
        React__default.createElement(Box, { className: cx('AruiTable-tableBody', classes === null || classes === void 0 ? void 0 : classes.tableBody), style: styles === null || styles === void 0 ? void 0 : styles.tableBody }, rowsDisplay),
        footerDisplay && (React__default.createElement(Box, { className: cx('AruiTable-tableFooter', classes === null || classes === void 0 ? void 0 : classes.tableFooter), style: styles === null || styles === void 0 ? void 0 : styles.tableFooter }, footerDisplay))));
};

const ElevatedLoading = (props) => {
    const { expectedSize } = props;
    const rows = useMemo(() => {
        const display = [];
        for (let i = 0; i < expectedSize; i++) {
            display.push(React__default.createElement(Skeleton, { key: i, animation: 'wave', variant: 'rectangular', sx: {
                    height: '42px',
                    width: '100%',
                    margin: '10px 0',
                    borderRadius: (theme) => `${theme.shape.borderRadius}px`
                } }));
        }
        return display;
    }, [expectedSize]);
    return (React__default.createElement(Stack, { sx: {
            width: '100%'
        }, alignItems: 'center' },
        React__default.createElement(Stack, { direction: 'row', spacing: 3, justifyContent: 'space-between', sx: {
                padding: '10px',
                width: '100%',
                boxSizing: 'border-box'
            } },
            React__default.createElement(Typography, { sx: { width: '100px' }, variant: 'h6' },
                React__default.createElement(Skeleton, { animation: 'wave' })),
            React__default.createElement(Typography, { sx: { width: '100px' }, variant: 'h6' },
                React__default.createElement(Skeleton, { animation: 'wave' })),
            React__default.createElement(Typography, { sx: { width: '100px' }, variant: 'h6' },
                React__default.createElement(Skeleton, { animation: 'wave' })),
            React__default.createElement(Typography, { sx: { width: '100px' }, variant: 'h6' },
                React__default.createElement(Skeleton, { animation: 'wave' }))),
        rows));
};

const GroundedLoading = (props) => {
    const { expectedSize } = props;
    const headerCell = (React__default.createElement(TableCell, null,
        React__default.createElement(Typography, { sx: { width: '120px' }, variant: 'h6' },
            React__default.createElement(Skeleton, { animation: 'wave' }))));
    const bodyCell = (React__default.createElement(TableCell, null,
        React__default.createElement(Typography, { sx: { width: '90px' } },
            React__default.createElement(Skeleton, { animation: 'wave' }))));
    const rows = useMemo(() => {
        const display = [];
        for (let i = 0; i < expectedSize; i++) {
            display.push(React__default.createElement(TableRow, { key: i },
                bodyCell,
                bodyCell,
                bodyCell,
                bodyCell));
        }
        return display;
    }, [expectedSize]);
    return (React__default.createElement(Table$1, null,
        React__default.createElement(TableHead, null,
            React__default.createElement(TableRow, null,
                headerCell,
                headerCell,
                headerCell,
                headerCell)),
        React__default.createElement(TableBody, null, rows)));
};

const defaultColumn = {
    width: 100
};
const Table = (props) => {
    const { data, columns, tableOptions, page, handlePageChange, onPageChange, isLoading, totalPages, setSelectedRowIds, isSelectableRow, variant = 'elevated', renderSubComponent, className, classes, styles, withFooter = false, onRowClicked, noToggleAllPageRowsSelected = false, renderRowHoveredComponent, header, getRowId, expectedSize = 10, expandIcon, expandIconPosition = 'start', expandInElevatedRow = false, toggleExpandOnRowClicked = false, additionalRowsProps, getRowLink, sx } = props, other = __rest(props, ["data", "columns", "tableOptions", "page", "handlePageChange", "onPageChange", "isLoading", "totalPages", "setSelectedRowIds", "isSelectableRow", "variant", "renderSubComponent", "className", "classes", "styles", "withFooter", "onRowClicked", "noToggleAllPageRowsSelected", "renderRowHoveredComponent", "header", "getRowId", "expectedSize", "expandIcon", "expandIconPosition", "expandInElevatedRow", "toggleExpandOnRowClicked", "additionalRowsProps", "getRowLink", "sx"]);
    const isSelectabale = !!setSelectedRowIds;
    const isExpandable = !!renderSubComponent;
    const isPaginated = !!page && !!totalPages && totalPages > 1;
    const useVariableHooks = useCallback((hooks) => {
        const expanderRow = {
            id: 'expander',
            accessor: 'expander',
            Cell: ({ row }) => {
                return (React__default.createElement("div", { onClick: (e) => e.stopPropagation() },
                    React__default.createElement(IconButton, Object.assign({}, row.getToggleRowExpandedProps()),
                        React__default.createElement(Box, { sx: {
                                transform: row.isExpanded && expandIconPosition === 'start'
                                    ? 'rotate(-180deg)'
                                    : row.isExpanded && expandIconPosition === 'end'
                                        ? 'rotate(180deg)'
                                        : '',
                                transition: '0.2s',
                                display: 'flex'
                            } }, expandIcon || (React__default.createElement(Arrow, { key: 'expanderIcon', color: '#353945', width: '20px', height: '20px', style: {
                                transform: 'rotate(-90deg)'
                            } }))))));
            },
            maxWidth: 50,
            className: 'AruiTable-actionColumn'
        };
        // @ts-ignore
        hooks.allColumns.push((columns) => [
            ...(isExpandable && expandIconPosition === 'start'
                ? [expanderRow]
                : []),
            ...(isSelectabale
                ? [
                    {
                        id: 'selection',
                        accessor: 'selection',
                        Header: ({ 
                        // @ts-ignore
                        getToggleAllPageRowsSelectedProps }) => {
                            return noToggleAllPageRowsSelected ? (React__default.createElement("div", null)) : (React__default.createElement(CheckBox, Object.assign({}, getToggleAllPageRowsSelectedProps())));
                        },
                        Cell: ({ row }) => {
                            const isSelectable = isSelectableRow
                                ? isSelectableRow(row)
                                : true;
                            return (isSelectable && (React__default.createElement(CheckBox, Object.assign({}, row.getToggleRowSelectedProps(), { onClick: (event) => event.stopPropagation() }))));
                        },
                        maxWidth: 50,
                        className: 'AruiTable-actionColumn'
                    }
                ]
                : []),
            ...columns,
            ...(isExpandable && expandIconPosition === 'end' ? [expanderRow] : [])
        ]);
    }, [
        isSelectabale,
        isExpandable,
        noToggleAllPageRowsSelected,
        expandIcon,
        expandIconPosition
    ]);
    const { getTableProps, headerGroups, footerGroups, rows, prepareRow, state: { selectedRowIds }, toggleRowExpanded, selectedFlatRows } = UseCompleteTable(variant, Object.assign({ data,
        columns, initialState: { pageIndex: 0, pageSize: data.length }, manualPagination: true, pageCount: totalPages, autoResetSelectedRows: false, getRowId: getRowId, 
        // @ts-ignore
        defaultColumn: defaultColumn }, tableOptions), useExpanded, usePagination, useRowSelect, useVariableHooks);
    useEffect(() => {
        const selectedOptions = selectedRowIds;
        // In same case selectedFlatRows contains only the rows of the current page.
        // When ToggleAllPageRowsSelected is checked, we need to unselect not selectable rows
        selectedFlatRows.forEach((d) => {
            const val = getRowId ? getRowId(d.original) : d.id;
            const isRowSelected = isSelectableRow ? isSelectableRow(d) : true;
            if (isRowSelected) {
                selectedOptions[val] = true;
            }
            else {
                delete selectedOptions[val];
            }
        });
        setSelectedRowIds && setSelectedRowIds(selectedOptions);
    }, [selectedFlatRows, selectedRowIds, setSelectedRowIds]);
    const tableProps = useMemo(() => getTableProps(), [getTableProps]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TableContainer, Object.assign({ className: cx('AruiTable-root', className), sx: variant === 'elevated'
                ? Object.assign({ padding: (theme) => `0px ${theme.spacing(1.5)}`, paddingBottom: (theme) => `${theme.spacing(1.5)}`, boxSizing: 'border-box', '& .AruiTable-principaleTableRow:hover': onRowClicked || getRowLink
                        ? {
                            borderColor: 'secondary.main',
                            cursor: 'pointer'
                        }
                        : {} }, sx) : Object.assign({ '& .AruiTable-principaleTableRow:hover': onRowClicked || getRowLink
                    ? {
                        background: '#D9DBE14D',
                        cursor: 'pointer'
                    }
                    : {} }, sx), variant: variant, getRowLink: getRowLink, expandInElevatedRow: expandInElevatedRow }, other),
            header,
            isLoading &&
                (variant === 'elevated' ? (React__default.createElement(ElevatedLoading, { expectedSize: expectedSize })) : (React__default.createElement(GroundedLoading, { expectedSize: expectedSize }))),
            !isLoading &&
                (variant === 'elevated' ? (React__default.createElement(ElevatedBase, { headerGroups: headerGroups, footerGroups: footerGroups, withFooter: withFooter, getRowLink: getRowLink, prepareRow: prepareRow, rows: rows, tableProps: tableProps, classes: classes, onRowClicked: onRowClicked, selectedRowIds: selectedRowIds, page: page, renderSubComponent: renderSubComponent, renderRowHoveredComponent: renderRowHoveredComponent, styles: styles, expandInRow: expandInElevatedRow, toggleRowExpanded: toggleRowExpanded, toggleExpandOnRowClicked: toggleExpandOnRowClicked, getRowId: getRowId, additionalRowsProps: additionalRowsProps })) : (React__default.createElement(GroundedBase, { withFooter: withFooter, headerGroups: headerGroups, footerGroups: footerGroups, selectedRowIds: selectedRowIds, page: page, prepareRow: prepareRow, getRowLink: getRowLink, rows: rows, tableProps: tableProps, classes: classes, onRowClicked: onRowClicked, renderSubComponent: renderSubComponent, renderRowHoveredComponent: renderRowHoveredComponent, styles: styles, toggleRowExpanded: toggleRowExpanded, toggleExpandOnRowClicked: toggleExpandOnRowClicked, getRowId: getRowId, additionalRowsProps: additionalRowsProps })))),
        isPaginated ? (React__default.createElement(Pagination, { className: 'AruiTable-pagination', onPageChange: onPageChange || handlePageChange, page: page, totalPage: totalPages })) : undefined));
};

const UserMenu = (props) => {
    const { currentUser, loggedMenu = [], notLoggedMenu = [], defaultOpen = true, classes, styles, className, sx } = props, other = __rest(props, ["currentUser", "loggedMenu", "notLoggedMenu", "defaultOpen", "classes", "styles", "className", "sx"]);
    if (!currentUser) {
        return (React__default.createElement(Box, { className: cx('AruiUserMenu-root', className), id: other.id, style: other.style, sx: Object.assign({ borderTop: '1px solid #E0E0E0', backgroundColor: 'white' }, sx) },
            React__default.createElement(Menu$2, { menu: notLoggedMenu, className: cx('AruiUserMenu-menu', classes === null || classes === void 0 ? void 0 : classes.menu), style: styles === null || styles === void 0 ? void 0 : styles.menu })));
    }
    return (React__default.createElement(Accordion, Object.assign({ defaultExpanded: defaultOpen, className: cx('AruiUserMenu-root', className), sx: Object.assign({ boxShadow: 'none' }, sx) }, other),
        React__default.createElement(AccordionSummary, { expandIcon: React__default.createElement(ExpandMoreRounded, null), "aria-controls": 'panel1a-content', id: 'panel1a-header', sx: {
                borderTop: '1px solid #E0E0E0'
            }, className: cx('AruiUserMenu-summary', classes === null || classes === void 0 ? void 0 : classes.summary), style: styles === null || styles === void 0 ? void 0 : styles.summary },
            React__default.createElement(Presentation, { label: `${currentUser.givenName} ${currentUser.familyName}`, subLabel: currentUser.role, className: cx('AruiUserMenu-presentation', classes === null || classes === void 0 ? void 0 : classes.presentation), style: styles === null || styles === void 0 ? void 0 : styles.presentation })),
        React__default.createElement(AccordionDetails, { sx: {
                padding: '0px'
            }, className: cx('AruiUserMenu-details', classes === null || classes === void 0 ? void 0 : classes.details), style: styles === null || styles === void 0 ? void 0 : styles.details },
            React__default.createElement(Menu$2, { menu: loggedMenu, className: cx('AruiUserMenu-menu', classes === null || classes === void 0 ? void 0 : classes.menu), style: styles === null || styles === void 0 ? void 0 : styles.menu, sx: {
                    paddingTop: '0px'
                } }))));
};

const Main = styled('main', {
    shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'drawerWidth' && prop !== 'openDrawer'
})(({ isMobile, drawerWidth, openDrawer, theme }) => ({
    flexGrow: 1,
    marginLeft: isMobile || !openDrawer ? '' : `${drawerWidth}px`,
    width: isMobile || !openDrawer ? '100vw' : `calc(100vw - ${drawerWidth}px)`,
    height: '100vh',
    overflow: 'auto',
    transition: !openDrawer
        ? theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
        : theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        })
}));
const StandAloneAppLayout = (props) => {
    const { children, menu, logo, open, userMenuProps, drawerProps, mainProps, drawerContent, defaultOpenButton = true, defaultCloseButton = true, drawerPaddingTop, classes, styles } = props;
    const theme = useTheme();
    const { theme: g2Theme, openDrawer, toggleOpenDrawer } = useContext(ThemeContext);
    const isMobile = g2Theme.drawerAbsolutePositionBreakpoint === 'always'
        ? true
        : useMediaQuery(theme.breakpoints.down(g2Theme.drawerAbsolutePositionBreakpoint));
    const currentOpen = open !== undefined ? open : openDrawer;
    const PerManentHeader = useMemo(() => g2Theme.permanentHeader, [g2Theme.permanentHeader]);
    return (React__default.createElement(React__default.Fragment, null,
        PerManentHeader && (React__default.createElement(Box, { sx: {
                position: 'fixed',
                zIndex: 2000,
                top: 0,
                left: 0,
                width: g2Theme.drawerWidth
            } },
            React__default.createElement(PerManentHeader, { toggleOpenDrawer: toggleOpenDrawer, openDrawer: currentOpen }))),
        defaultOpenButton && (React__default.createElement(IconButton, { sx: {
                zIndex: 1001,
                position: 'fixed',
                top: 10,
                left: 10,
                width: 'fit-content'
            }, onClick: toggleOpenDrawer },
            React__default.createElement(Menu, null))),
        React__default.createElement(Drawer, Object.assign({}, drawerProps, { className: cx('AruiStandAloneAppLayout-drawer', classes === null || classes === void 0 ? void 0 : classes.drawer), style: styles === null || styles === void 0 ? void 0 : styles.drawer, sx: Object.assign({ width: g2Theme.drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': {
                    width: g2Theme.drawerWidth,
                    boxSizing: 'border-box',
                    border: 'unset',
                    height: `100%`,
                    overflow: 'visible',
                    visibility: 'visible !important',
                    paddingTop: drawerPaddingTop
                        ? drawerPaddingTop
                        : PerManentHeader
                            ? '90px'
                            : undefined
                } }, drawerProps === null || drawerProps === void 0 ? void 0 : drawerProps.sx), variant: isMobile ? 'temporary' : 'persistent', ModalProps: {
                keepMounted: true
            }, onClose: toggleOpenDrawer, anchor: 'left', open: currentOpen }),
            defaultCloseButton && (React__default.createElement(IconButton, { sx: {
                    zIndex: 1001,
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    width: 'fit-content'
                }, onClick: toggleOpenDrawer },
                React__default.createElement(Menu, null))),
            React__default.createElement(Box, { className: cx('AruiStandAloneAppLayout-scrollableContainer', classes === null || classes === void 0 ? void 0 : classes.scrollableContainer), style: styles === null || styles === void 0 ? void 0 : styles.scrollableContainer, sx: {
                    height: '100%',
                    width: '100%',
                    overflow: 'auto'
                } },
                React__default.createElement(AppMenu, { menu: menu !== null && menu !== void 0 ? menu : [], logo: logo }),
                drawerContent),
            userMenuProps && (React__default.createElement(UserMenu, Object.assign({ defaultOpen: !isMobile }, userMenuProps, { className: cx('AruiStandAloneAppLayout-userMenu', classes === null || classes === void 0 ? void 0 : classes.userMenu), style: styles === null || styles === void 0 ? void 0 : styles.userMenu, sx: {
                    position: 'relative',
                    bottom: '0px',
                    width: '100%',
                    margin: '0px !important'
                } })))),
        React__default.createElement(CssBaseline, null),
        React__default.createElement(Main, Object.assign({}, mainProps, { openDrawer: currentOpen, drawerWidth: g2Theme.drawerWidth, className: cx('AruiStandAloneAppLayout-main', classes === null || classes === void 0 ? void 0 : classes.main), style: styles === null || styles === void 0 ? void 0 : styles.main, isMobile: isMobile, sx: Object.assign({ bgcolor: (theme) => theme.palette.background.default }, mainProps === null || mainProps === void 0 ? void 0 : mainProps.sx) }), children)));
};

const Section = (props) => {
    const { children, headerProps, bottomActionsProps, classes, styles, className, sx, flexContent = false } = props, other = __rest(props, ["children", "headerProps", "bottomActionsProps", "classes", "styles", "className", "sx", "flexContent"]);
    const theme = useTheme();
    const actionsDisplay = useMemo(() => {
        if (!bottomActionsProps)
            return undefined;
        return (React__default.createElement(Actions, Object.assign({}, bottomActionsProps, { sx: {
                marginTop: !flexContent ? (theme) => theme.spacing(3) : ''
            } })));
    }, [bottomActionsProps, flexContent]);
    const headerDisplay = useMemo(() => {
        if (!headerProps)
            return undefined;
        return (React__default.createElement(Header, Object.assign({ bgcolor: '#ffffff', sx: {
                borderRadius: (theme) => `${theme.shape.borderRadius * 1.5}px ${theme.shape.borderRadius * 1.5}px 0 0`
            }, zIndex: 200 }, headerProps)));
    }, [headerProps]);
    return (React__default.createElement(Paper, Object.assign({ elevation: 0, className: cx('AruiSection-root', className), sx: Object.assign({ overflow: 'hidden', display: 'flex', borderRadius: (theme) => `${theme.shape.borderRadius * 1.5}px` }, sx) }, other),
        React__default.createElement(Box, { className: cx('AruiSection-overflowWrapper', classes === null || classes === void 0 ? void 0 : classes.overflowWrapper), style: styles === null || styles === void 0 ? void 0 : styles.overflowWrapper, sx: {
                maxHeight: '100%',
                overflow: 'auto',
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            } },
            headerDisplay,
            React__default.createElement(Box, { sx: {
                    [theme.breakpoints.down('sm')]: {
                        padding: (theme) => theme.spacing(1),
                        paddingTop: (theme) => theme.spacing(2),
                        gap: flexContent ? (theme) => theme.spacing(2) : ''
                    },
                    padding: (theme) => theme.spacing(3),
                    flexGrow: 1,
                    display: flexContent ? 'flex' : '',
                    flexDirection: flexContent ? 'column' : '',
                    gap: flexContent ? (theme) => theme.spacing(3) : ''
                }, className: cx('AruiSection-contentContainer', classes === null || classes === void 0 ? void 0 : classes.contentContainer), style: styles === null || styles === void 0 ? void 0 : styles.contentContainer },
                children,
                actionsDisplay))));
};

const stopPropagation = (e) => e.stopPropagation();
const TableCellLink = (props) => {
    const { value, target = '_blank' } = props;
    if (!value)
        return React__default.createElement(Typography, null, "-");
    return (React__default.createElement(Link$1, { component: Link, componentProps: { to: value.url }, onClick: stopPropagation, rel: 'noopener', target: target, color: '#697077' }, value.label));
};

const TableCellContact = (props) => {
    const { value } = props;
    if (!(value === null || value === void 0 ? void 0 : value.email) && !(value === null || value === void 0 ? void 0 : value.phone))
        return React__default.createElement(Typography, null, "-");
    return (React__default.createElement(Stack, { direction: 'row', sx: {
            gap: '5px'
        } },
        (value === null || value === void 0 ? void 0 : value.email) && (React__default.createElement(Tooltip, { helperText: value === null || value === void 0 ? void 0 : value.email },
            React__default.createElement(IconButton, { onClick: stopPropagation, href: 'mailto:' + (value === null || value === void 0 ? void 0 : value.email) },
                React__default.createElement(MailRounded, null)))),
        (value === null || value === void 0 ? void 0 : value.phone) && (React__default.createElement(Tooltip, { helperText: value === null || value === void 0 ? void 0 : value.phone },
            React__default.createElement(IconButton, { onClick: stopPropagation, href: 'tel:' + (value === null || value === void 0 ? void 0 : value.phone) },
                React__default.createElement(LocalPhoneRounded, null))))));
};

const TableCellDate = (props) => {
    const { value } = props;
    if (!value)
        return React__default.createElement(Typography, null, "-");
    const dateString = new Date(value).toLocaleDateString();
    return React__default.createElement(Typography, null, dateString);
};

const TableCellNumber = (props) => {
    const { value, isCurrency = false, language = 'fr', fractionDigits = 2 } = props;
    const number = !value
        ? '-'
        : formatNumber(value, language, fractionDigits, isCurrency);
    return React__default.createElement(Typography, null, number);
};

const TableCellProfile = (props) => {
    const { value } = props;
    if (!(value === null || value === void 0 ? void 0 : value.givenName) && !(value === null || value === void 0 ? void 0 : value.familyName))
        return React__default.createElement(Typography, null, "-");
    return React__default.createElement(Presentation, { label: `${value === null || value === void 0 ? void 0 : value.givenName} ${value === null || value === void 0 ? void 0 : value.familyName}` });
};

const TableCellText = (props) => {
    var _a;
    const { value, componentProps } = props;
    const text = !((_a = value === null || value === void 0 ? void 0 : value.trim()) === null || _a === void 0 ? void 0 : _a.length) ? '-' : value;
    return (React__default.createElement(Typography, Object.assign({}, componentProps, { sx: Object.assign({ WebkitLineClamp: 2, lineClamp: '2', display: '-webkit-box', WebkitBoxOrient: 'vertical', textOverflow: 'ellipsis', overflow: 'hidden' }, componentProps === null || componentProps === void 0 ? void 0 : componentProps.sx) }), text));
};

const LimitedList = (props) => {
    const { values = [], limit, listedComponent } = props, other = __rest(props, ["values", "limit", "listedComponent"]);
    const tagsDisplay = useMemo(() => {
        const limited = limit ? values.slice(0, limit) : values;
        const Component = listedComponent;
        return limited.map((el) => { var _a; return React__default.createElement(Component, Object.assign({}, el, { key: (_a = el.key) !== null && _a !== void 0 ? _a : el.label })); });
    }, [values, limit, listedComponent]);
    const textRest = useMemo(() => {
        if (limit && limit <= values.length - 1) {
            const rest = values.slice(limit, values.length - 1).map((el) => el.label);
            return rest.join(', ');
        }
        return undefined;
    }, [values, limit, listedComponent]);
    return (React__default.createElement(Stack, Object.assign({ direction: 'row', gap: 0.5, flexWrap: 'wrap' }, other),
        tagsDisplay,
        textRest && (React__default.createElement(Tooltip, { helperText: textRest },
            React__default.createElement(Chip, { label: `${values.length - (limit !== null && limit !== void 0 ? limit : 0)} +`, sx: {
                    bgcolor: 'primary.main',
                    color: 'white'
                } })))));
};

const TableCellTag = (props) => {
    const { variant = 'chip', multiple = false, options, value } = props, other = __rest(props, ["variant", "multiple", "options", "value"]);
    const selected = useMemo(() => value
        ? (Array.isArray(value) ? value : [value]).map((val) => options.find((option) => option.key === val))
        : undefined, [value, options]);
    return (React__default.createElement(LimitedList, Object.assign({ listedComponent: variant === 'chip' ? Chip : StatusTag, values: selected }, other)));
};

const TableCellChip = (props) => {
    return React__default.createElement(TableCellTag, Object.assign({ variant: 'chip' }, props));
};

const TableCellStatus = (props) => {
    return React__default.createElement(TableCellTag, Object.assign({ variant: 'status' }, props));
};

const TableCellIconTag = (props) => {
    var _a;
    const { value, options, size = 'small' } = props, other = __rest(props, ["value", "options", "size"]);
    const selected = useMemo(() => options === null || options === void 0 ? void 0 : options.find((option) => option.key === value), [options, value]);
    return (React__default.createElement(Stack, Object.assign({ gap: 1, direction: 'row', alignItems: 'center' }, other),
        React__default.createElement(Box, { sx: {
                background: (_a = selected === null || selected === void 0 ? void 0 : selected.color) !== null && _a !== void 0 ? _a : '#FAF8F3',
                borderRadius: '50%',
                padding: size === 'small' ? '7px' : size === 'medium' ? '9px' : '11px',
                display: 'flex'
            } }, typeof (selected === null || selected === void 0 ? void 0 : selected.icon) === 'string' ? (React__default.createElement("img", { src: selected === null || selected === void 0 ? void 0 : selected.icon, style: {
                width: size === 'small' ? '20px' : size === 'medium' ? '24px' : '35px',
                height: size === 'small' ? '20px' : size === 'medium' ? '24px' : '35px'
            } })) : (selected === null || selected === void 0 ? void 0 : selected.icon)),
        React__default.createElement(Typography, { variant: 'body2' }, selected === null || selected === void 0 ? void 0 : selected.label)));
};

const getColumnGenerator = (CellElement) => (params) => {
    const { getCellProps } = params, other = __rest(params
    //@ts-ignore
    , ["getCellProps"]);
    //@ts-ignore
    return Object.assign(Object.assign({}, other), { cell: ({ row }) => React__default.createElement(CellElement, Object.assign({}, getCellProps(row.original))) });
};
const columnsGenerators = {
    contact: getColumnGenerator(TableCellContact),
    date: getColumnGenerator(TableCellDate),
    link: getColumnGenerator(TableCellLink),
    number: getColumnGenerator(TableCellNumber),
    profile: getColumnGenerator(TableCellProfile),
    text: getColumnGenerator(TableCellText),
    chip: getColumnGenerator(TableCellChip),
    status: getColumnGenerator(TableCellStatus),
    iconTag: getColumnGenerator(TableCellIconTag),
    tag: getColumnGenerator(TableCellTag)
};
const ColumnFactory = (params) => {
    const { generateColumns } = params;
    const columns = generateColumns(columnsGenerators);
    if (Array.isArray(columns))
        return columns;
    const finalColumns = [];
    Object.keys(columns).forEach((key) => {
        var _a;
        const column = columns[key];
        column.id = (_a = column.id) !== null && _a !== void 0 ? _a : key;
        finalColumns.push(column);
    });
    return finalColumns;
};
const ColumnFactoryV1 = (params) => {
    var _a;
    const { generateColumns } = params;
    //@ts-ignore
    const columnsObject = generateColumns(columnsGenerators);
    const columns = [];
    for (const key in columnsObject) {
        const column = columnsObject[key];
        column.id = Array.isArray(columnsObject) ? column.id : (_a = column.id) !== null && _a !== void 0 ? _a : key;
        //@ts-ignore
        column.Cell = column.cell;
        //@ts-ignore
        delete column.cell;
        //@ts-ignore
        columns.push(column);
    }
    return columns;
};

const TableBase = (props) => {
    const { classes, onRowClicked, renderSubComponent, styles, tableState, withFooter, renderRowHoveredComponent, expandInRow, additionalRowsProps = {}, variant, getRowLink } = props;
    //@ts-ignore
    const TableComponent = variant === 'elevated' ? 'div' : undefined;
    //@ts-ignore
    const TableHeadComponent = variant === 'elevated' ? 'div' : undefined;
    //@ts-ignore
    const TableBodyComponent = variant === 'elevated' ? 'div' : undefined;
    //@ts-ignore
    const TableFooterComponent = variant === 'elevated' ? 'div' : undefined;
    //@ts-ignore
    const TableRowComponent = variant === 'elevated' ? 'div' : undefined;
    //@ts-ignore
    const TableCellComponent = variant === 'elevated' ? 'div' : undefined;
    const rowsDisplay = tableState.getRowModel().rows.map((row) => {
        var _a;
        const cell = (React__default.createElement(React__default.Fragment, null,
            row.getVisibleCells().map((cell) => {
                const column = cell.column.columnDef;
                return (React__default.createElement(TableCell, { component: TableCellComponent, key: cell.id, className: cx(column.className, 'AruiTable-tableCell', classes === null || classes === void 0 ? void 0 : classes.tableCell), style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableCell), sx: variant === 'elevated'
                        ? {
                            flex: '100 0 auto',
                            width: '100px'
                        }
                        : undefined }, flexRender(column.cell, cell.getContext())));
            }),
            !!renderRowHoveredComponent && (React__default.createElement(TableCell, { component: TableCellComponent, sx: {
                    padding: 0,
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                }, className: cx('AruiTable-rowHoveredComponentContainer', classes === null || classes === void 0 ? void 0 : classes.rowHoveredComponentContainer), style: styles === null || styles === void 0 ? void 0 : styles.rowHoveredComponentContainer }, renderRowHoveredComponent(row)))));
        const extProps = (_a = additionalRowsProps[tableState._getRowId(row.original, row.index)]) !== null && _a !== void 0 ? _a : additionalRowsProps === null || additionalRowsProps === void 0 ? void 0 : additionalRowsProps.all;
        return (React__default.createElement(Fragment, { key: row.id },
            React__default.createElement(TableRow, Object.assign({ component: TableRowComponent }, extProps, { onClick: () => {
                    onRowClicked && onRowClicked(row);
                }, className: cx(extProps === null || extProps === void 0 ? void 0 : extProps.className, 'AruiTable-principaleTableRow', 'AruiTable-tableRow', classes === null || classes === void 0 ? void 0 : classes.tableRow), style: styles === null || styles === void 0 ? void 0 : styles.tableRow, sx: variant === 'elevated'
                    ? {
                        display: expandInRow && variant === 'elevated' ? undefined : 'flex'
                    }
                    : undefined }),
                expandInRow && variant === 'elevated' ? (React__default.createElement(Box, { sx: {
                        display: 'flex'
                    } }, cell)) : (cell),
                expandInRow && variant === 'elevated' && (React__default.createElement(Collapse, { in: row.getIsExpanded(), timeout: 'auto', unmountOnExit: true }, renderSubComponent && renderSubComponent(row))),
                getRowLink && (React__default.createElement(TableCell, { component: TableCellComponent, sx: {
                        padding: 0,
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                        top: 0,
                        left: 0
                    }, className: 'AruiTable-rowLinkContainer' },
                    React__default.createElement(Link, Object.assign({}, getRowLink(row), { style: {
                            position: 'absolute',
                            width: '100%',
                            height: '100%'
                        } }))))),
            (!expandInRow || variant === 'grounded') && (React__default.createElement(TableRow, { component: TableRowComponent, className: cx('AruiTable-tableRow', classes === null || classes === void 0 ? void 0 : classes.tableRow), style: styles === null || styles === void 0 ? void 0 : styles.tableRow },
                React__default.createElement(TableCell, { component: TableCellComponent, className: cx('AruiTable-tableCell', classes === null || classes === void 0 ? void 0 : classes.tableCell), style: styles === null || styles === void 0 ? void 0 : styles.tableCell, sx: { paddingBottom: 0, paddingTop: 0 }, colSpan: variant === 'grounded' ? 100 : undefined },
                    React__default.createElement(Collapse, { in: row.getIsExpanded(), timeout: 'auto', unmountOnExit: true }, renderSubComponent && renderSubComponent(row)))))));
    });
    const headerDisplay = tableState.getHeaderGroups().map((headerGroup) => (React__default.createElement(TableRow, { component: TableRowComponent, className: cx('AruiTable-tableHeaderRow', classes === null || classes === void 0 ? void 0 : classes.tableHeaderRow), style: styles === null || styles === void 0 ? void 0 : styles.tableHeaderRow, key: headerGroup.id, sx: variant === 'elevated'
            ? {
                display: 'flex'
            }
            : undefined }, headerGroup.headers.map((header) => {
        const column = header.column.columnDef;
        return (React__default.createElement(TableCell, { component: TableCellComponent, key: header.id, className: cx(column.className, 'AruiTable-tableHeaderCell', classes === null || classes === void 0 ? void 0 : classes.tableHeaderCell), style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableHeaderCell), sx: variant === 'elevated'
                ? {
                    flex: '100 0 auto',
                    width: '100px'
                }
                : undefined, variant: variant === 'grounded' ? 'head' : undefined }, header.id !== 'selection' ? (React__default.createElement(Typography, { variant: 'subtitle1' }, flexRender(column.header, header.getContext()))) : (flexRender(column.header, header.getContext()))));
    }))));
    const footerDisplay = !withFooter
        ? undefined
        : tableState.getFooterGroups().map((footerGroup) => (React__default.createElement(TableRow, { component: TableRowComponent, key: footerGroup.id, className: cx('AruiTable-tableFooterRow', classes === null || classes === void 0 ? void 0 : classes.tableFooterRow), style: styles === null || styles === void 0 ? void 0 : styles.tableFooterRow, sx: variant === 'elevated'
                ? {
                    display: 'flex'
                }
                : undefined }, footerGroup.headers.map((header) => {
            const column = header.column.columnDef;
            return (React__default.createElement(TableCell, { component: TableCellComponent, key: header.id, className: cx(column.className, 'AruiTable-tableFooterCell', classes === null || classes === void 0 ? void 0 : classes.tableFooterCell), style: Object.assign(Object.assign({}, column.style), styles === null || styles === void 0 ? void 0 : styles.tableFooterCell), sx: variant === 'elevated'
                    ? {
                        flex: '100 0 auto',
                        width: '100px'
                    }
                    : undefined, variant: variant === 'grounded' ? 'body' : undefined }, flexRender(column.footer, header.getContext())));
        }))));
    return (React__default.createElement(Table$1, { component: TableComponent, className: cx('AruiTable-table', classes === null || classes === void 0 ? void 0 : classes.table), style: styles === null || styles === void 0 ? void 0 : styles.table },
        React__default.createElement(TableHead, { component: TableHeadComponent, className: cx('AruiTable-tableHead', classes === null || classes === void 0 ? void 0 : classes.tableHead), style: styles === null || styles === void 0 ? void 0 : styles.tableHead }, headerDisplay),
        React__default.createElement(TableBody, { component: TableBodyComponent, className: cx('AruiTable-tableBody', classes === null || classes === void 0 ? void 0 : classes.tableBody), style: styles === null || styles === void 0 ? void 0 : styles.tableBody }, rowsDisplay),
        footerDisplay && (React__default.createElement(TableFooter, { component: TableFooterComponent, className: cx('AruiTable-tableFooter', classes === null || classes === void 0 ? void 0 : classes.tableFooter), style: styles === null || styles === void 0 ? void 0 : styles.tableFooter }, footerDisplay))));
};

const TableV2 = (props) => {
    const { page, handlePageChange, onPageChange, isLoading, totalPages, variant = 'grounded', renderSubComponent, className, classes, styles, withFooter = false, onRowClicked, renderRowHoveredComponent, header, expectedSize = 10, expandInElevatedRow = false, additionalRowsProps, tableState, getRowLink, sx } = props, other = __rest(props, ["page", "handlePageChange", "onPageChange", "isLoading", "totalPages", "variant", "renderSubComponent", "className", "classes", "styles", "withFooter", "onRowClicked", "renderRowHoveredComponent", "header", "expectedSize", "expandInElevatedRow", "additionalRowsProps", "tableState", "getRowLink", "sx"]);
    const isPaginated = !!page && !!totalPages && totalPages > 1;
    return (React.createElement(React.Fragment, null,
        React.createElement(TableContainer, Object.assign({ className: cx('AruiTable-root', className), sx: variant === 'elevated'
                ? Object.assign({ padding: (theme) => `0px ${theme.spacing(1.5)}`, paddingBottom: (theme) => `${theme.spacing(1.5)}`, boxSizing: 'border-box', '& .AruiTable-principaleTableRow:hover': !!onRowClicked || !!getRowLink
                        ? {
                            borderColor: 'secondary.main',
                            cursor: 'pointer'
                        }
                        : {} }, sx) : Object.assign({ '& .AruiTable-principaleTableRow:hover': !!onRowClicked || !!getRowLink
                    ? {
                        background: '#D9DBE14D',
                        cursor: 'pointer'
                    }
                    : {} }, sx), variant: variant, getRowLink: getRowLink, expandInElevatedRow: expandInElevatedRow }, other),
            header,
            isLoading &&
                (variant === 'elevated' ? (React.createElement(ElevatedLoading, { expectedSize: expectedSize })) : (React.createElement(GroundedLoading, { expectedSize: expectedSize }))),
            !isLoading && (React.createElement(TableBase, { getRowLink: getRowLink, tableState: tableState, withFooter: withFooter, classes: classes, onRowClicked: onRowClicked, variant: variant, renderSubComponent: renderSubComponent, renderRowHoveredComponent: renderRowHoveredComponent, styles: styles, expandInRow: expandInElevatedRow, additionalRowsProps: additionalRowsProps }))),
        isPaginated ? (React.createElement(Pagination, { className: 'AruiTable-pagination', onPageChange: onPageChange || handlePageChange, page: page, totalPage: totalPages })) : undefined));
};

const useTable = (options) => {
    const { columns, enableExpanding = false, enableRowSelection = false, expandIconPosition = 'start', RowSelectionPosition = 'start', expandIcon, noToggleAllPageRowsSelected = false } = options, other = __rest(options, ["columns", "enableExpanding", "enableRowSelection", "expandIconPosition", "RowSelectionPosition", "expandIcon", "noToggleAllPageRowsSelected"]);
    const extendedColumns = useMemo(() => {
        const expanderRow = {
            id: 'expander',
            cell: ({ row }) => {
                return (React__default.createElement("div", { onClick: (e) => e.stopPropagation() },
                    React__default.createElement(IconButton, { className: 'AruiTable-actionColumn', onClick: () => row.toggleExpanded() },
                        React__default.createElement(Box, { sx: {
                                transform: row.getIsExpanded() && expandIconPosition === 'start'
                                    ? 'rotate(-180deg)'
                                    : row.getIsExpanded() && expandIconPosition === 'end'
                                        ? 'rotate(180deg)'
                                        : '',
                                transition: '0.2s',
                                display: 'flex'
                            } }, expandIcon || (React__default.createElement(Arrow, { key: 'expanderIcon', color: '#353945', width: '20px', height: '20px', style: {
                                transform: 'rotate(-90deg)'
                            } }))))));
            },
            className: 'AruiTable-actionColumn'
        };
        const rowSelection = {
            id: 'selection',
            header: ({ table }) => {
                return noToggleAllPageRowsSelected ? (React__default.createElement("div", null)) : (React__default.createElement(CheckBox, { onChange: table.getToggleAllRowsSelectedHandler(), checked: table.getIsAllRowsSelected(), indeterminate: table.getIsSomeRowsSelected() }));
            },
            cell: ({ row }) => {
                if (!row.getCanSelect())
                    return undefined;
                return (React__default.createElement(CheckBox, { onChange: (_, value) => row.toggleSelected(value), checked: row.getIsSelected(), onClick: (event) => event.stopPropagation() }));
            },
            className: 'AruiTable-actionColumn'
        };
        return [
            ...(enableExpanding && expandIconPosition === 'start'
                ? [expanderRow]
                : []),
            ...(enableRowSelection && RowSelectionPosition === 'start'
                ? [rowSelection]
                : []),
            ...columns,
            ...(enableRowSelection && RowSelectionPosition === 'end'
                ? [rowSelection]
                : []),
            ...(enableExpanding && expandIconPosition === 'end' ? [expanderRow] : [])
        ];
    }, [
        columns,
        enableExpanding,
        enableRowSelection,
        expandIconPosition,
        expandIcon,
        noToggleAllPageRowsSelected
    ]);
    return useReactTable(Object.assign(Object.assign({ getCoreRowModel: getCoreRowModel(), getExpandedRowModel: getExpandedRowModel(), enableExpanding,
        enableRowSelection }, other), { columns: extendedColumns }));
};

const Stepper = (props) => {
    const { steps = [], sx, activeStep, orientation = 'vertical', activeColor = 'primary' } = props, rest = __rest(props, ["steps", "sx", "activeStep", "orientation", "activeColor"]);
    const isHorizontal = orientation === 'horizontal';
    const stepsDisplay = useMemo(() => steps.map((step, index) => (React__default.createElement(Step, Object.assign({}, step, { sx: Object.assign({ '& .MuiStepConnector-line': {
                borderColor: (theme) => activeStep != undefined && index === activeStep + 1
                    ? theme.palette[activeColor].main
                    : ''
            } }, step.sx) }),
        isHorizontal && index === steps.length - 1 && (React__default.createElement(StepConnector, { style: {
                left: '40px'
            }, sx: {
                '& .MuiStepConnector-line': {
                    borderColor: (theme) => `${activeStep != undefined && index === activeStep
                        ? theme.palette[activeColor].main
                        : activeStep != undefined && index < activeStep
                            ? theme.palette.success.main
                            : '#9E9E9E'} !important`
                }
            } })),
        React__default.createElement(StepLabel, { StepIconComponent: AvStepIcon, StepIconProps: {
                //@ts-ignore
                activeColor: activeColor
            } }, step.label)))), [steps, activeStep, isHorizontal, activeColor]);
    const localSx = useMemo(() => orientation === 'vertical'
        ? Object.assign({ display: 'block', '& .MuiStepLabel-labelContainer': {
                width: 'unset'
            }, '& .MuiStepLabel-root': {
                padding: '0'
            }, '& .MuiStepConnector-line': {
                height: '80px',
                borderLeftWidth: '2px',
                borderColor: '#9E9E9E'
            }, '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
                borderColor: (theme) => theme.palette[activeColor].main
            }, '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
                borderColor: (theme) => theme.palette.success.main
            }, '& .MuiStepConnector-root': {
                marginLeft: '16px'
            }, '& .MuiStepLabel-label': {
                fontSize: '1rem',
                fontWeight: 600,
                color: '#9E9E9E'
            }, '& .MuiStepLabel-label.Mui-active': {
                color: (theme) => theme.palette[activeColor].main
            }, '& .MuiStepLabel-label.Mui-completed': {
                color: '#353945'
            } }, sx) : Object.assign({ '& .MuiStepLabel-root': {
            flexDirection: 'row !important',
            alignItems: 'flex-end !important'
        }, '& .MuiStepLabel-label': {
            height: '70px',
            marginBottom: '15px',
            marginRight: '-15px',
            textAlign: 'left !important',
            marginLeft: '5px',
            marginTop: 'unset !important',
            fontSize: '1rem',
            fontWeight: 600,
            color: '#9E9E9E',
            overflow: 'hidden',
            WebkitLineClamp: '3',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis'
        }, '& .MuiStepConnector-root': {
            width: 'calc(100% - 32px)',
            left: 'calc(-100% + 40px)',
            height: 0,
            bottom: '16.5px',
            right: 'unset',
            top: 'unset'
        }, '& .MuiStepConnector-line': {
            borderTopWidth: '2px',
            borderColor: '#9E9E9E'
        }, '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
            borderColor: (theme) => theme.palette.success.main
        }, '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            borderColor: (theme) => theme.palette.success.main
        }, '& .MuiStepLabel-label.Mui-active': {
            color: (theme) => theme.palette[activeColor].main
        }, '& .MuiStepLabel-label.Mui-completed': {
            color: '#353945'
        } }, sx), [orientation, sx, activeColor]);
    return (React__default.createElement(Stepper$1, Object.assign({}, rest, { sx: localSx, activeStep: activeStep, orientation: orientation, alternativeLabel: isHorizontal }), stepsDisplay));
};
const Mydiv = styled('div')({});
function AvStepIcon(props) {
    const { active, completed, className, style, icon, activeColor } = props;
    return (React__default.createElement(Mydiv, { className: className, style: style, sx: Object.assign({ borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px' }, (active
            ? {
                background: (theme) => theme.palette[activeColor].main,
                border: (theme) => `2px ${theme.palette[activeColor].main} solid`,
                color: 'white'
            }
            : completed
                ? {
                    background: (theme) => theme.palette.success.main,
                    border: (theme) => `2px ${theme.palette.success.main} solid`,
                    color: 'white'
                }
                : {
                    background: 'none',
                    border: `2px #9E9E9E solid`,
                    color: '#9E9E9E'
                })) }, completed ? (React__default.createElement(CheckRounded, { className: 'QontoStepIcon-completedIcon' })) : (React__default.createElement(Typography, { variant: 'subtitle1' }, String(icon)))));
}

const SidePageStepper = (props) => {
    const { headerComponent, stepperProps, sx } = props, other = __rest(props, ["headerComponent", "stepperProps", "sx"]);
    return (React__default.createElement(Drawer, Object.assign({ sx: Object.assign({ width: '350px', flexShrink: 0, '& .MuiDrawer-paper': {
                width: '350px',
                boxSizing: 'border-box',
                background: '#F2F4F5',
                border: 'none',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: (theme) => theme.spacing(3)
            } }, sx), variant: 'permanent', anchor: 'left' }, other),
        headerComponent,
        React__default.createElement(Stepper, Object.assign({}, stepperProps, { sx: Object.assign({ marginTop: '120px' }, stepperProps.sx) }))));
};

export { App, AppBarLayout, AppLayout, AppMenu, ColumnFactory, ColumnFactoryV1, ConfirmationPopUp, Header, ItemsLayout, LimitedList, Page, PageContext, PageContextProvider, PopUp, Section, SidePageStepper, StandAloneAppLayout, Stepper, Table, TableCellChip, TableCellContact, TableCellDate, TableCellIconTag, TableCellLink, TableCellNumber, TableCellProfile, TableCellStatus, TableCellTag, TableCellText, TableV2, TabsMenu, ToolsMenu, ToolsPanel, UserMenu, usePage, useTable };
//# sourceMappingURL=index.es.js.map
